import { observable, computed, action, runInAction, reaction } from "mobx";
import _ from "underscore";
import API from "../libs/api";
import moment from "moment";
import axios from "axios";

class CartEntry {
  @observable item;
  @observable.shallow addons = [];
  @observable notes = [];
  @observable adjustedTotal = null; // Observable to store the adjusted total

  reactionHandler;

  constructor({ item, addons, notes, reward, reactionHandler }) {
    this.item = item;
    this.addons = addons;
    this.notes = notes;
    this.reward = reward ? reward : {};
    this.reactionHandler = reactionHandler;

    reaction(
      () => {
        reactionHandler(this.item.id, this.addons.length);
      },
      () => {}
    );
  }

  @computed get hasNote() {
    for (let i = 0; i < this.notes.length; i++) {
      if (this.notes[i] !== "") return true;
    }
    return false;
  }

  @computed get quantity() {
    //// console.log(this.addons.length);
    // console.log('p');
    return this.addons.length;
  }

  @action removeAddon(addonListIndex) {
    this.addons.splice(addonListIndex, 1);
  }

  // Pattern = 1401 1 a222 1 notes, 1401 1 a111 b111 1
  // b prefix stands for mandatory
  @action payload() {
    let payload = [];

    _.each(this.addons, (addonList, addonListIndex) => {
      if (
        (this.item.isCustomize && addonListIndex === 0) ||
        !this.item.isCustomize
      ) {
        let header = this.item.id + " 1";

        // Remember to replace commas with another character

        if (this.notes[addonListIndex] && this.notes[addonListIndex] !== "") {
          header = header + " " + this.notes[addonListIndex].replace(/,/g, " ");
        }
        if (
          this.reward &&
          this.reward.redeem_code &&
          this.reward.redeem_code !== ""
        ) {
          header = header + " [EberDiscount]";
        }
        payload.push(header);

        const sorted = this.sortAddons(addonList);

        // Push the mandatory items first
        if ("undefined" in sorted) {
          _.each(sorted["undefined"], (addon) => {
            payload.push(`b${addon.id} ${addon.quantity} `);
          });
        }

        delete sorted["undefined"];
        const keys = Object.keys(sorted);
        for (let i = 0; i < keys.length; i++) {
          _.each(sorted[keys[i]], (addon) => {
            if (addon.modifiers && addon.modifiers !== "") {
              payload.push(
                `a${addon.id} ${addon.quantity} ${addon.modifiers} `
              );
            } else {
              payload.push(`a${addon.id} ${addon.quantity} `);
            }
          });
        }
      }
    });

    return payload.join(", ");
  }

  // Return a sorted addon list by using groupOrder presented in addons
  @action sortAddons(addonList) {
    let sortedList = {};

    _.each(addonList, (addonGroup, index) => {
      _.each(addonGroup, (addon, index) => {
        if (index === 0) sortedList[addon.groupOrder] = [];

        if (addon.quantity > 0) sortedList[addon.groupOrder].push(addon);
      });
    });
    return sortedList;
  }

  @action updateSpecialRequest(index, text) {
    this.notes[index] = text;
  }
}

class CartStore {
  menuStore;
  orderStore;
  tabHandler;
  @observable.shallow entries = []; // Stores an array of CartEntry
  @observable.shallow quantity_map = new Map();
  remarks = "";
  takeAway = true;
  CustomOrderId = "";
  @observable appliedReward = null; // Currently applied reward
  @observable updateTimestamp = Date.now(); // Used to trigger reactive updates

  constructor(menuStore, orderStore) {
    this.menuStore = menuStore;
    this.orderStore = orderStore;
    reaction(
      () => this.menuStore.controller,
      (ctrl) => {
        if (ctrl) this.fetchTaxConfig();
      },
      { fireImmediately: true }
    );

    // Iterate through menuList to setup quantity_map with initial values
    /* _.each(this.menuStore.menuList, val => {
		   _.each(val, item => {
			 this.quantity_map.set(item.id, 0);
		   });
		 });
	 	
	   const pendingOrder=localStorage.getItem(`${this.menuStore.controller}_cart`);
	   if(pendingOrder)
	   {
		 if (pendingOrder !== "undefined") {
			 const jsonPendingOrders = JSON.parse(pendingOrder);
			 //this.entries = jsonPendingOrders.map(entry => new CartEntry({ ...entry }));
		 _.each(jsonPendingOrders, entry => {
		   //this.entries.push(new CartEntry({ ...entry }));
		   this.addItem({ ...entry });
			   this.quantity_map.set(entry.item.id, entry.addons.length);
		 });
		 //_.each(this.entries, entry => {			
			//  this.quantity_map.set(entry.item.id, entry.addons.length);
		 //});
		   }
		  // this.entries=JSON.parse(pendingOrder);
		   	
	   } */
  }
  @action applyReward(reward) {
    // console.log('[Rewards Debug][store.applyReward] incoming reward', reward);
    if (!reward || !reward.id) {
      console.error("Invalid reward data:", reward);
      return;
    }

    // Keep last applied reward for backward compatibility
    this.appliedReward = reward;

    if (!this.menuStore.social) {
      this.menuStore.social = {};
    }

    // Helper to group rewards into high-level categories
    const getRewardCategory = (rw) => {
      const r = rw && (rw.selectedRedeem || rw);
      const t = r && r.type;
      // Treat cashback/stored-value as 'rebate'
      if (t === "cashback" || t === "stored-value") return "rebate";
      // Treat explicit voucher as 'voucher'
      if (t === "voucher") return "voucher";
      // Some vouchers with redeem options come as dollarValue/percentage
      // If voucherType exists, classify as voucher
      if (r && r.voucherType) return "voucher";
      // Fallback: use raw type
      return t || "unknown";
    };

    // Maintain a list of applied rewards (max 2 handled by caller/UI)
    const currentSocial = this.menuStore.social;
    // console.log('[Rewards Debug][store.applyReward] currentSocial before', currentSocial);
    let existingRewards = Array.isArray(currentSocial.appliedRewards)
      ? [...currentSocial.appliedRewards]
      : [];
    // Backward-compat: if there is a legacy single redeem, include it
    if (currentSocial.redeem) {
      const legacy = currentSocial.redeem;
      const legacyId = legacy.id || legacy.campaignId || legacy.redeem_code;
      const exists = existingRewards.some((r) => {
        const rId = (r && (r.id || r.campaignId || r.redeem_code)) || "";
        return rId === legacyId;
      });
      if (!exists) existingRewards.push(legacy);
    }

    // Replace any existing reward from the same category; keep others
    const newCategory = getRewardCategory(reward);
    // console.log('[Rewards Debug][store.applyReward] newCategory', newCategory, 'existingRewards', existingRewards.length);
    const filtered = existingRewards.filter(
      (rw) => getRewardCategory(rw) !== newCategory
    );
    // console.log('[Rewards Debug][store.applyReward] filtered', filtered.length);
    const updatedAppliedRewards = [...filtered, reward].slice(0, 2);
    // console.log('[Rewards Debug][store.applyReward] updatedAppliedRewards', updatedAppliedRewards.length);
    // console.log('[Rewards Debug][store.applyReward] updatedAppliedRewards content', updatedAppliedRewards.map(r => ({ id: r.id || r.campaignId, type: r.type, name: r.name })));

    // Update social snapshot
    this.menuStore.social = {
      ...currentSocial,
      redeem: reward, // last applied reward (legacy uses)
      appliedRewards: updatedAppliedRewards,
    };
    // console.log('[Rewards Debug][store.applyReward] updated social', this.menuStore.social);
    // console.log('[Rewards Debug][store.applyReward] appliedRewards after update', this.menuStore.social.appliedRewards);
    // console.log('[Rewards Debug][store.applyReward] appliedRewards length', this.menuStore.social.appliedRewards ? this.menuStore.social.appliedRewards.length : 'undefined');

    localStorage.setItem(
      `${this.menuStore.controller}_social`,
      JSON.stringify(this.menuStore.social)
    );

    // Force reactive update of cart totals
    this.resetEntries();

    // Ensure UI components re-render by updating an observable property
    this.updateTimestamp = Date.now();
    // console.log('[Rewards Debug][store.applyReward] updateTimestamp set', this.updateTimestamp);
  }

  @action addOrderByBackend(payload, id) {
    let orderId = payload.refno;
    let pingurl = payload.pingUrl;
    if (id !== "") {
      orderId = id;
      pingurl = null;
    }
    let allOrders = this.orderStore.lists;
    let newOrderlist = [];
    let isOrderFound = false;
    _.each(allOrders, (ordr) => {
      if (ordr.id === payload.refno) {
        isOrderFound = true;
        ordr.id = id;
        ordr.pingUrl = pingurl;
      }
      newOrderlist.push(ordr);
    });
    if (isOrderFound) {
      this.orderStore.lists = newOrderlist;
      this.orderStore.saveOrders();
    } else if (this.entries.length > 0) {
      this.menuStore.resetPostQA();
      localStorage.removeItem("is_opened_pre_question");
      this.orderStore.addOrder({
        id: orderId,
        status: null, // defaulted to pending status
        cartEntries: this.entries,
        pingUrl: payload.pingUrl,
      });
      // Empty the cart
      this.empty();
    }
  }
  @action prepareOrderParams(itemIds, order) {
    //let itemIds=this.state.excludedItesm;

    let payloadOrder = [];
    let filterCustomizeOrder = [];
    let entries = this.convertTOEntry(order.cartEntries, false);
    _.map(entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          !filterCustomizeOrder.indexOf(entry.item.id)) ||
        !entry.item.isCustomize
      ) {
        if (itemIds === "checkTable" || itemIds.indexOf(entry.item.id) > -1) {
          payloadOrder.push(entry.payload());
        }
      }
    });
    if (payloadOrder.length === 0) {
      return "";
    }
    let uuid = localStorage.getItem("uuid");
    payloadOrder = payloadOrder.join(", ");
    let payload = "";
    payload += "&order=" + encodeURIComponent(payloadOrder);
    payload += "&orderNo=" + order.orderNo;
    payload += "&key=" + order.id;
    payload += "&uuid=" + uuid;
    return payload;
  }

  @computed get cart() {
    return this.entries;
  }

  @computed get size() {
    return _.reduce(
      this.entries,
      (memo, entry) => {
        //return memo + entry.addons.length;
        return memo + this.quantity_map.get(entry.item.id);
      },
      0
    );
  }
  @computed get cartQty() {
    return _.reduce(
      this.entries,
      (memo, entry) => {
        //return memo + entry.addons.length;
        return memo + entry.addons.length;
      },
      0
    );
  }
  @computed get freeQty() {
    return _.reduce(
      this.entries,
      (memo, entry) => {
        let price = parseFloat(entry.item.price);
        if (price > 0) {
          return memo + 0;
        } else {
          return memo + this.quantity_map.get(entry.item.id);
        }
      },
      0
    );
  }
  @computed get orderAmount() {
    let total = 0;
    _.each(this.entries, (entry) => {
      total += parseFloat(entry.item.price) * entry.addons.length;
      _.each(entry.addons, (addonList) => {
        const keys = Object.keys(addonList);
        for (let i = 0; i < keys.length; i++) {
          const category = keys[i];
          if (category !== "undefined") {
            for (let x = 0; x < addonList[keys[i]].length; x++) {
              total +=
                addonList[keys[i]][x].price * addonList[keys[i]][x].quantity;
            }
          }
        }
      });
    });

    total = total.toFixed(parseFloat(this.menuStore.currencyDecimal));
    return total;
  }

  get total() {
    return this.appliedRewardDetails.baseTotal;
  }

  @computed get sub_total() {
    // SUBTOTAL should always show STANDARD prices (not membership prices)
    // This is the amount before any membership discounts are applied
    // Debug: Calculate standard subtotal (limit logging)
    if (!this._lastSubTotalLog || Date.now() - this._lastSubTotalLog > 1000) {
      //console.log('[CartStore.sub_total] Calculating STANDARD sub_total for', this.entries.length, 'entries');
      this._lastSubTotalLog = Date.now();
    }
    
    const subTotal = this.entries.reduce((sum, entry) => {
      let entryStandardTotal = 0;
      
      // Always use standard price for base item
      const baseStandardPrice = parseFloat(entry.item.price) || 0;
      entryStandardTotal += baseStandardPrice * entry.addons.length;
      
      //console.log(`[CartStore.sub_total] Entry: ${entry.item.name} - Base: ${baseStandardPrice} x ${entry.addons.length}`);

      // Calculate addon standard prices
      _.each(entry.addons, (addonList, addonListIndex) => {
        const keys = Object.keys(addonList);
        for (let i = 0; i < keys.length; i++) {
          const category = keys[i];
          if (category !== "undefined") {
            for (let x = 0; x < addonList[category].length; x++) {
              const addon = addonList[category][x];
              
              // Always use STANDARD price for subtotal
              let addonStandardPrice = parseFloat(addon.price) || 0;
              
              // If this addon has stored standard price, use it
              if (addon.standardPrice !== undefined) {
                addonStandardPrice = parseFloat(addon.standardPrice) || addonStandardPrice;
  
              } else {
                // Check for duplicate pattern - use the HIGHER price (standard)
                const sameNameAddons = addonList[category].filter(a => a.name === addon.name);
                
                if (sameNameAddons.length === 2) {
                  const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                  const higherPrice = prices[0]; // Standard price is higher
                  
                  if (parseFloat(addon.price) === higherPrice) {
                    addonStandardPrice = higherPrice;
    
                  } else {
                    // This is the membership price addon, find the standard price
                    addonStandardPrice = higherPrice;

                  }
                }
              }
              
              entryStandardTotal += addonStandardPrice * addon.quantity;

            }
          }
        }
      });


      
      return sum + entryStandardTotal;
    }, 0);

    //if (!this._lastSubTotalLog || Date.now() - this._lastSubTotalLog > 1000) {
      //console.log('[CartStore.sub_total] Final STANDARD subtotal:', subTotal);
    //}
    
    return subTotal.toFixed(parseFloat(this.menuStore.currencyDecimal || 2));
  }

  @action calculateRewardDiscoutPrice(selectedReward, total) {
    if (!selectedReward || !total || isNaN(total)) {
      return { actualPrice: 0, priceAmt: 0 };
    }

    let discount = 0;
    if (selectedReward.pos_redeem_method === "percentage") {
      discount =
        (parseFloat(total) *
          parseFloat(selectedReward.pos_redeem_percentage || 0)) /
        100;
    } else {
      discount = parseFloat(selectedReward.pos_redeem_amount || 0);
    }

    let newTotal = parseFloat(total) - discount;
    newTotal = Math.max(0, newTotal);

    return {
      actualPrice: parseFloat(total).toFixed(
        parseFloat(this.menuStore.currencyDecimal || 2)
      ),
      priceAmt: newTotal.toFixed(
        parseFloat(this.menuStore.currencyDecimal || 2)
      ),
    };
  }

  @action entryTotal(entry) {
    let total = 0;
    
    // Check if membership pricing should be used
    const tokenExpiry = localStorage.getItem(
      `${this.menuStore.controller}_advocado_token_expiry`
    );
    const now = new Date().getTime();
    let useMembership = false;
    if (tokenExpiry && parseInt(tokenExpiry) > now) {
      useMembership = true;
    }
    // Only logout if socialCheckout is true AND token is expired
    if (!useMembership && this.menuStore.socialCheckout === true) {
      this.menuStore.logout();
    }
    
    // Disable debug logging - too verbose
    // console.log(`[CartStore.entryTotal] Processing ${entry.item.name}, useMembership: ${useMembership}`);
    
    // Choose the appropriate base price based on membership status.
    // If membership pricing is valid and available, use it.
    const basePrice =
      useMembership && entry.item.membershipPrice
        ? parseFloat(entry.item.membershipPrice.price)
        : parseFloat(entry.item.price);



    // Multiply by the number of addon groups
    total += basePrice * entry.addons.length;

    // Process addon prices with membership pricing support
    // Each addon list represents one "instance" of the item, so process each separately
    _.each(entry.addons, (addonList, addonListIndex) => {

      
      const keys = Object.keys(addonList);
      for (let i = 0; i < keys.length; i++) {
        const category = keys[i];
        if (category !== "undefined") {
          for (let x = 0; x < addonList[category].length; x++) {
            const addon = addonList[category][x];
            let addonPrice = parseFloat(addon.price) || 0;
            
            // Apply membership pricing for addons if available
            if (useMembership) {
              // Check for stored membership pricing
              if (addon.hasMembershipPricing && addon.membershipPrice !== undefined) {
                addonPrice = parseFloat(addon.membershipPrice) || addonPrice;

              } else {
                // Fallback: Check for duplicate pattern (standard vs membership)
                const sameNameAddons = addonList[category].filter(a => a.name === addon.name && a.quantity > 0);
                
                if (sameNameAddons.length === 2) {
                  const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                  const standardPrice = prices[0];
                  const membershipPrice = prices[1];
                  
                  if (parseFloat(addon.price) === standardPrice) {
                    addonPrice = membershipPrice; // Use the lower price for membership

                  }
                }
              }
            }
            
            total += addonPrice * addon.quantity;

          }
        }
      }
    });


    return total.toFixed(parseFloat(this.menuStore.currencyDecimal));
  }
  @action checkCartsStatus() {
    _.each(this.entries, (entry) => {
      this.updateNotavilable(entry.item);
      // if(entry.reward && entry.reward.id && entry.reward.id!=="")
      // {
      // rewardName=entry.reward.redeem_name;
      // }
    });
    //return rewardName;
  }
  @action checkRewardItemInCart() {
    let rewardName = "";
    _.each(this.entries, (entry) => {
      // this.updateNotavilable(entry.item);
      if (
        entry.reward &&
        entry.reward.redeem_code &&
        entry.reward.redeem_code !== ""
      ) {
        rewardName = entry.reward.redeem_name ? entry.reward.redeem_name : "";
      }
    });
    return rewardName.trim();
  }
  @action updateNotavilable(item) {
    let ntA = this.menuStore.notAvailable;
    var index = ntA.indexOf(item.id);
    if (ntA.length > 0 && index !== -1) {
      this.menuStore.notAvailable.splice(index, 1);
    }

    let avail = this.menuStore.isAvailable(item);
    if (!avail) {
      this.menuStore.notAvailable.push(item.id);
    }
  }
  @action renderOlderOrder() {
    //const { itemModal } = this.menuStore;

    _.each(this.menuStore.menuList, (val) => {
      _.each(val, (item) => {
        this.quantity_map.set(item.id, 0);
      });
    });
    //this.menuStore.notAvailable=[];
    const pendingOrder = localStorage.getItem(
      `${this.menuStore.controller}_cart`
    );
    if (pendingOrder) {
      if (pendingOrder !== "undefined") {
        const jsonPendingOrders = JSON.parse(pendingOrder);
        this.entries = this.convertTOEntry(jsonPendingOrders, true);
        _.each(this.entries, (entry) => {
          if (entry.item.isCustomize && entry.item.hasAddons) {
            let tQty = this.getAddonsQty(entry.addons);
            //// console.log(tQty,'999');
            //this.quantity_map.set(entry.item.id, tQty);
            this.updateQuantity(entry, tQty);
          }
        });
        //this.resetEntries();
      }
    }
  }

  // Normalize priceReceipt to consistent format
  normalizePriceReceipt(priceReceipt, total) {
    // If priceReceipt is already a JSON string or object, try to parse it
    if (priceReceipt) {
      try {
        if (typeof priceReceipt === 'string') {
          const parsed = JSON.parse(priceReceipt);
          if (parsed && typeof parsed === 'object') {
            return priceReceipt; // Return as JSON string
          }
        } else if (typeof priceReceipt === 'object') {
          return JSON.stringify(priceReceipt); // Convert to JSON string
        }
      } catch (e) {
        // If parsing fails, treat as simple string/number
      }
    }

    // If priceReceipt is a simple string/number or total is provided, create unified format
    const amount = priceReceipt || total || "0.00";
    const numericAmount = parseFloat(amount) || 0;
    
    // Create unified JSON format
    const unifiedReceipt = {
      sub: numericAmount,
      sub_name: "SubTotal",
      taxBefore: 0,
      discount: 0,
      tax1: 0,
      tax1_name: "GST",
      tax2: 0,
      total: numericAmount,
      total_name: "Total"
    };
    
    return JSON.stringify(unifiedReceipt);
  }

  // Calculate completeness score for an order (higher score = more complete)
  calculateOrderCompletenessScore(order) {
    let score = 0;
    
    // Base score for having basic order info
    if (order.id) score += 10;
    if (order.orderNo) score += 10;
    if (order.status !== undefined) score += 10;
    if (order.timestamp) score += 10;
    
    // Bonus for detailed info (HTML receipt)
    if (order.info && order.info.length > 100) {
      score += 50; // High bonus for HTML receipt
    } else if (order.info && order.info.length > 0) {
      score += 20; // Medium bonus for any info
    }
    
    // Bonus for complete cart entries
    if (order.cartEntries && Array.isArray(order.cartEntries)) {
      score += order.cartEntries.length * 5; // 5 points per cart entry
      
      order.cartEntries.forEach(entry => {
        if (entry.item && entry.item.name) score += 5;
        if (entry.item && entry.item.price) score += 5;
        if (entry.quantity) score += 5;
        if (entry.addons && Array.isArray(entry.addons)) score += 2;
        if (entry.notes && Array.isArray(entry.notes)) score += 2;
      });
    }
    
    // Bonus for additional fields
    if (order.table) score += 5;
    if (order.payment_method) score += 5;
    if (order.priceReceipt) score += 10;
    if (order.total) score += 5;
    if (order.uuid) score += 5;
    if (order.receipt_id) score += 5;
    
    // Bonus for proper data types (number vs string)
    if (order.cartEntries && order.cartEntries.length > 0) {
      const firstEntry = order.cartEntries[0];
      if (firstEntry.item && typeof firstEntry.item.id === 'number') {
        score += 5; // Bonus for numeric ID
      }
    }
    
    console.log(`📊 Order ${order.id} completeness score: ${score}`);
    return score;
  }

  @action fetchOrdersFromServer() {
    console.log('🔄 Fetching orders from server for "Remind Order"...');
    
    // Get current UUID and receipt_id from cart or localStorage
        let uuid = this.CustomOrderId || localStorage.getItem('uuid');
        let receiptId = localStorage.getItem(`${this.menuStore.controller}_receipt_id`);
        
        console.log('🔍 Initial UUID:', uuid, 'Receipt ID:', receiptId);
        
        // Return a Promise so it can be used with .then()
        return new Promise((resolve, reject) => {
          // Priority: Use UUID from localStorage first, only call API if no UUID exists
          const getRealUUID = () => {
            // If we already have a UUID from localStorage, use it
            if (uuid) {
              console.log('✅ Using existing UUID from localStorage:', uuid);
              return Promise.resolve(uuid);
            }
            
            // Only call API if no UUID in localStorage
            console.log('🔄 No UUID in localStorage, fetching from API...');
            return API.getRealUUID()
        .then((res) => {
                console.log('📋 API Response from getRealUUID:', res);
                                 if (res && res.success && res.uuid) {
                   console.log('✅ Real UUID found from API:', res.uuid);
                   // Store the new UUID in localStorage for future use
                   localStorage.setItem('uuid', res.uuid);
                   return res.uuid;
                 }
                return null;
        })
        .catch((err) => {
                console.log('❌ getRealUUID endpoint not available, using fallback...');
          return null;
        });
    };

              // Try to get recent orders from server with real UUID
        const tryGetRecentOrders = (realUUID) => {
          const uuidToUse = realUUID || uuid;
          console.log('🔍 Using UUID for getRecentOrders:', uuidToUse);
          
          // If no UUID available, skip this method
          if (!uuidToUse) {
            console.log('⚠️ No UUID available for getRecentOrders, skipping...');
        return Promise.resolve(null);
      }
      
          return API.getRecentOrders(null, null, uuidToUse, receiptId) // Get all orders for UUID, no timeWindow/limit needed
          .then((res) => {
              console.log('📋 API Response from getRecentOrders:', res);
              return res;
          })
          .catch((err) => {
              console.log('❌ getRecentOrders endpoint not available, trying fallback...');
            return null;
          });
        };
      
      // Fallback: try to get order by UUID for more detailed/updated information
      const tryGetOrderByUuid = (realUUID) => {
        const uuidToUse = realUUID || uuid;
        console.log('🔍 Using UUID for getOrderByUuid:', uuidToUse);
        
        // If no UUID available, skip this method
        if (!uuidToUse) {
          console.log('⚠️ No UUID available for getOrderByUuid, skipping...');
          return Promise.resolve(null);
        }
        
        return API.getOrderByUuid(uuidToUse, receiptId)
          .then((res) => {
            console.log('📋 API Response from getOrderByUuid:', res);
            return res;
          })
          .catch((err) => {
            console.log('❌ getOrderByUuid endpoint not available');
            return null;
          });
      };

                // First get real UUID, then try to get orders
          getRealUUID()
            .then((realUUID) => {
              if (realUUID) {
                // Try both methods with real UUID
                return Promise.all([tryGetRecentOrders(realUUID), tryGetOrderByUuid(realUUID)]);
              } else {
                console.log('❌ No UUID available from localStorage or API');
                // No fallback - just try with null UUID
                return Promise.all([tryGetRecentOrders(null), tryGetOrderByUuid(null)]);
              }
            })
            .catch((err) => {
              console.log('❌ Error getting real UUID');
              // No fallback - just try with null UUID
              return Promise.all([tryGetRecentOrders(null), tryGetOrderByUuid(null)]);
            })
      .then(([recentOrdersRes, orderByUuidRes]) => {
        console.log('📋 Recent Orders Response:', recentOrdersRes);
        console.log('📋 Order by UUID Response:', orderByUuidRes);
        
        // Combine results from both APIs intelligently
        let allOrders = [];
        
        // Add orders from getRecentOrders if available
        if (recentOrdersRes && recentOrdersRes.success && recentOrdersRes.orders) {
          allOrders = allOrders.concat(recentOrdersRes.orders);
        }
        
        // Add order from getOrderByUuid if available (usually more detailed/updated)
        if (orderByUuidRes && orderByUuidRes.success && orderByUuidRes.order) {
          // getOrderByUuid returns single order object, not array
          allOrders.push(orderByUuidRes.order);
        }
        
        console.log('📋 Combined orders from both APIs:', allOrders);
        
        if (allOrders.length > 0) {
          console.log('✅ Orders found from server:', allOrders);
          
          // Remove duplicates and prioritize orders with more complete information
          const uniqueOrders = [];
          const seenIds = new Map(); // Use Map to store order with best info for each ID
          
          // Sort by timestamp descending to keep the latest version
          const sortedOrders = allOrders.sort((a, b) => {
            const timeA = new Date(a.timestamp || 0);
            const timeB = new Date(b.timestamp || 0);
            return timeB - timeA;
          });
          
          sortedOrders.forEach(order => {
            if (!seenIds.has(order.id)) {
              seenIds.set(order.id, order);
              uniqueOrders.push(order);
            } else {
              // Compare with existing order to keep the one with more complete information
              const existingOrder = seenIds.get(order.id);
              const existingScore = this.calculateOrderCompletenessScore(existingOrder);
              const currentScore = this.calculateOrderCompletenessScore(order);
              
              console.log(`🔄 Comparing duplicate orders for ${order.id}:`, {
                existing: { score: existingScore, info: existingOrder.info ? existingOrder.info.substring(0, 50) + '...' : 'empty' },
                current: { score: currentScore, info: order.info ? order.info.substring(0, 50) + '...' : 'empty' }
              });
              
              if (currentScore > existingScore) {
                console.log(`✅ Replacing order ${order.id} with more complete version`);
                // Replace the existing order in both Map and array
                seenIds.set(order.id, order);
                const index = uniqueOrders.findIndex(o => o.id === order.id);
                if (index !== -1) {
                  uniqueOrders[index] = order;
                }
              } else {
                console.log(`🔄 Skipping less complete duplicate order:`, order.id);
              }
            }
          });
          
          console.log(`📊 Removed ${allOrders.length - uniqueOrders.length} duplicate orders`);
          
          // Filter and add only valid orders to local storage
          const validOrders = uniqueOrders.filter(order => {
            // Check if order has valid cart entries
            const hasValidCartEntries = order.cartEntries && Array.isArray(order.cartEntries) && order.cartEntries.length > 0;
            
            // Check for valid items (handle both old and new cart entry structures)
            const hasValidItems = hasValidCartEntries && order.cartEntries.some(entry => {
              if (entry.item) {
                // New structure: entry.item.name, entry.item.price
                // Accept items with price 0.00 (free items, promotional items, etc.)
                return entry.item.name && entry.item.name !== "Item 20";
              } else if (entry.name) {
                // Old structure: entry.name, entry.price
                // Accept items with price 0.00 (free items, promotional items, etc.)
                return entry.name && entry.name !== "Item 20";
              }
              return false;
            });
            
            // Check for valid total amount (either priceReceipt or total field)
            
            
            // Accept orders with total 0.00 (free orders, promotional orders, etc.)
            const hasValidTotal = (order.priceReceipt !== null && order.priceReceipt !== undefined) || 
                                 (order.total !== null && order.total !== undefined);
            
            // Note: We no longer require info to be non-empty since getOrderByUuid often returns empty info
            if (!hasValidItems || !hasValidTotal) {
              console.log('⚠️ Skipping invalid order:', order.id, '- Invalid items or no total amount');
              return false;
            }
            
            return true;
          });
            
            console.log(`📊 Filtered ${validOrders.length} valid orders from ${uniqueOrders.length} unique orders (${allOrders.length} total including duplicates)`);
            
                       // Add valid orders to local storage
           validOrders.forEach(order => {
             // Normalize priceReceipt format
             const normalizedPriceReceipt = this.normalizePriceReceipt(order.priceReceipt, order.total);
             
            this.orderStore.addOrder({
              id: order.id,
              status: order.status,
              cartEntries: order.cartEntries,
              orderNo: order.orderNo,
               timestamp: order.created_at || order.timestamp,
               table: order.table || "",
               spotOrderId: order.spotOrderId || "",
               isNew: order.isNew || false,
               priceReceipt: normalizedPriceReceipt
            });
          });
          
           // Remove any existing duplicates from orderStore
           const removedDuplicates = this.orderStore.removeDuplicates();
           if (removedDuplicates > 0) {
             console.log(`🧹 Cleaned up ${removedDuplicates} duplicate orders from orderStore`);
           }
            
            // Also store to localStorage with UUID key format for duplicated:Unknown
            // Use the uuid from the outer scope (which might be temporary)
            if (uuid) {
              const uuidOrderKey = `${uuid}_order`;
              const existingOrders = localStorage.getItem(uuidOrderKey);
              let ordersArray = [];
              
              if (existingOrders && existingOrders !== "undefined") {
                try {
                  ordersArray = JSON.parse(existingOrders);
                } catch (e) {
                  console.log('❌ Error parsing existing orders:', e);
                  ordersArray = [];
                }
              }
              
                           // Add only valid orders to the array (avoid duplicates)
             const existingIds = new Set(ordersArray.map(existing => existing.id));
             
                           validOrders.forEach(order => {
                // Convert cart entries to the expected format
                const convertedCartEntries = (order.cartEntries || []).map(entry => {
                  if (entry.item) {
                    // New structure: already in correct format
                    return entry;
                  } else {
                    // Old structure: convert to new format
                    return {
                      item: {
                        id: entry.id || entry.itemId,
                        name: entry.name,
                        price: entry.price,
                        description: entry.description || "",
                        thumbnail: entry.thumbnail || "",
                        category: entry.category || ""
                      },
                      quantity: entry.quantity || 1,
                      addons: entry.addons || [],
                      notes: entry.notes || []
                    };
                  }
                });
                
                const orderData = {
                  id: order.id,
                  status: order.status,
                  cartEntries: convertedCartEntries,
                  orderNo: order.orderNo,
                  timestamp: order.created_at || order.timestamp,
                  table: order.table || "",
                  spotOrderId: order.spotOrderId || "",
                  isNew: order.isNew || false,
                  priceReceipt: this.normalizePriceReceipt(order.priceReceipt, order.total)
                };
               
               if (!existingIds.has(order.id)) {
                 // Add new order only if it doesn't exist
                 ordersArray.push(orderData);
                 existingIds.add(order.id);
               } else {
                 // Update existing order if it's newer
                 const existingIndex = ordersArray.findIndex(existing => existing.id === order.id);
                 const existingTimestamp = new Date(ordersArray[existingIndex].timestamp || 0);
                 const newTimestamp = new Date(orderData.timestamp || 0);
                 
                 if (newTimestamp > existingTimestamp) {
                   ordersArray[existingIndex] = orderData;
                   console.log('🔄 Updated existing order with newer data:', order.id);
                 }
               }
             });
              
                           // Save back to localStorage
             localStorage.setItem(uuidOrderKey, JSON.stringify(ordersArray));
             const newOrdersCount = ordersArray.length - (existingOrders && existingOrders !== "undefined" ? JSON.parse(existingOrders).length : 0);
             console.log(`📦 ${validOrders.length} valid orders processed, ${newOrdersCount} new orders added to localStorage with key: ${uuidOrderKey}`);
            }
            
            console.log('📦 Valid orders added to local storage');
                       // Return response with filtered valid orders
           const filteredResponse = {
             success: true,
             orders: validOrders,
             total: validOrders.length,
             message: `Found ${validOrders.length} valid order(s) from ${uniqueOrders.length} unique orders (${allOrders.length} total including duplicates)`
           };
            resolve(filteredResponse); // Resolve with the filtered response
        } else {
          console.log('📭 No orders found from server');
            resolve(null); // Resolve with null if no orders found
        }
      })
      .catch((err) => {
        console.log('❌ Error fetching orders from server:', err);
          reject(err); // Reject with the error
        });
      });
  }
  @action convertTOEntry(jsonPendingOrders, isMapping) {
    const { itemModal } = this.menuStore;
    let allEntries = [];
    _.each(jsonPendingOrders, (entry) => {
      let item = this.menuStore.getItemByCat(
        entry.item.id,
        entry.item.category
      );
      if (item) {
        let allAdones = entry.addons;
        //// console.log(entry.item.name,allAdones);
        _.each(allAdones, (add, index) => {
          _.each(add, (sadd, sindex) => {
            _.each(sadd, (adItem, aindex) => {
              let cloned = itemModal.makeAddonObject(adItem);
              
              // Re-enhance addon with membership pricing after restore
              if (item.addons && item.addons[sindex] && item.addons[sindex][aindex]) {
                const originalAddon = item.addons[sindex][aindex];
                
                // Find duplicate addons with same name but different prices
                const sameNameAddons = item.addons[sindex].filter(a => a.name === originalAddon.name);
                if (sameNameAddons.length === 2) {
                  const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                  const standardPrice = prices[0];
                  const membershipPrice = prices[1];
                  
                  // Enhance the cloned addon with membership pricing
                  cloned.standardPrice = standardPrice;
                  cloned.membershipPrice = membershipPrice;
                  cloned.hasMembershipPricing = true;
                  
                  //console.log('[CartStore.convertTOEntry] Re-enhanced addon with membership pricing:', cloned.name, 'Standard:', standardPrice, 'Member:', membershipPrice);
                }
              }
              
              allAdones[index][sindex][aindex] = cloned;
            });
          });
        });
        let enty = new CartEntry({
          item: item,
          addons: allAdones,
          notes: entry.notes,
          reward: entry.reward,
          reactionHandler: (itemId, quantity) => {
            if (isMapping) {
              this.quantity_map.set(itemId, quantity);
            }
          },
        });

        allEntries.push(enty);
        //this.updateNotavilable(item);
      }
    });
    return allEntries;
  }

  @action repeatOrder(order) {
    let enteries = order.cartEntries;
    if (!enteries || enteries === null) {
      let orderList = this.orderStore.lists;
      //// console.log(orderList,'000');
      /* orderList.forEach(oder => {*/
      for (let ol = orderList.length - 1; ol > 0; ol--) {
        //// console.log(5);
        let oder = orderList[ol];
        if (oder.id === order.id) {
          enteries = oder.cartEntries;
          //return true;
          break;
        }
      }
      // });
    }
    _.each(enteries, (entry) => {
      this.addItem({ ...entry });
      this.quantity_map.set(entry.item.id, entry.addons.length);
      //this.menuStore.isAvailable(entry.item);
    });
  }
  @action updateQuantity(entry, quantity) {
    const difference = Math.abs(entry.addons.length - quantity);

    for (let i = 0; i < difference; i++) {
      if (quantity > entry.addons.length) {
        this.addItem({ item: entry.item, addons: null, notes: [""] });

        let faddonList = entry.addons[0];
        //// console.log(faddonList);
        //entry.addons[entry.addons.length-1]=faddonList;
        let lastaddonList = entry.addons[entry.addons.length - 1];
        //// console.log(lastaddonList,faddonList);
        let keys = Object.keys(faddonList);
        _.each(keys, (key, index) => {
          _.each(faddonList[key], (addon, addonIndex) => {
            lastaddonList[key][addonIndex].quantity =
              faddonList[key][addonIndex].quantity;
          });
        });

        entry.addons[entry.addons.length - 1] = lastaddonList;
        this.menuStore.sendGoogleAnalytics(
          this.menuStore.googleAddItem,
          entry.item.name,
          this.menuStore.controller,
          entry.item.price * entry.addons.length * 100
        );
      } else {
        entry.addons.pop();
        entry.notes.pop();
        this.menuStore.sendGoogleAnalytics(
          this.menuStore.googleRemoveItem,
          entry.item.name,
          this.menuStore.controller,
          entry.item.price * entry.addons.length * 100
        );

        if (quantity === 0) this.removeItem(entry.item);
      }
    }
  }

  // Menu items can be added or removed
  @action addItemFromMenu(item, quantity) {
    // let entry = null;
    // for (let i = 0; i < this.entries.length; i++) {
    // if (item.id === this.entries[i].item.id) entry = this.entries[i];
    // }
    let entry = this.getEntry(item);
    // Entry found means we can either add or remove item
    if (entry) {
      this.updateQuantity(entry, quantity);
    } else {
      this.addItem({ item: item, addons: null, notes: [""] });
      if (quantity > 1) {
        //for coco
        this.addItemFromMenu(item, quantity);
      }
    }
    return entry;
  }
  @action getAddonsIds(itemAddon, addonSlected) {
    //// console.log(addonSlected,'addonSlected');
    let firstItemAdon = itemAddon[0];
    let firstAddonSlected = addonSlected[0];
    let keys = Object.keys(firstAddonSlected);
    let isFoundMatch = true;
    // let selAddonIds=[];
    _.each(keys, (key, index) => {
      _.each(firstAddonSlected[key], (addon, addonIndex) => {
        let existing = firstItemAdon[key][addonIndex];
        let existingMod = existing.modifiers ? existing.modifiers : "";
        let newMod = addon.modifiers ? addon.modifiers : "";
        if (
          addon.quantity === 1 &&
          existing.quantity === 1 &&
          existingMod === newMod
        ) {
        } else if (addon.quantity === 1 || existing.quantity === 1) {
          isFoundMatch = false;
          //break;
        }
      });
    });
    return isFoundMatch;
  }
  @action getLeastAddonPrice(itemAddon) {
    let total = 0;
    _.each(itemAddon, (addonList) => {
      //// console.log(firstAddonSlected,'itemAddon');
      let keys = Object.keys(addonList);
      _.each(keys, (key, index) => {
        let price = 0;
        let min = 1;
        let minTotal = 0;
        _.each(addonList[key], (addon, addonIndex) => {
          //// console.log(addon, 'yyyyy')
          let addPr = parseFloat(addon.price);
          if (
            minTotal <= min &&
            addPr >= 0 &&
            (addPr <= price || price === 0)
          ) {
            price = addPr;
            min = parseInt(addon.min);
            minTotal++;
          }
        });
        //// console.log(min, price, 'min, price')
        total = total + min * price;
      });
    });
    return parseFloat(total);
  }
  @action getAddonsNames(addonSlected) {
    let firstAddonSlected = addonSlected[0];
    let keys = Object.keys(firstAddonSlected);
    let selAddonName = [];
    _.each(keys, (key, index) => {
      _.each(firstAddonSlected[key], (addon, addonIndex) => {
        if (addon.quantity === 1 && addon.groupName) {
          selAddonName.push(addon.name);
        }
      });
    });
    return selAddonName.join(", ");
  }

  @action getAddonsNamesList(addonSlected) {
    let firstAddonSlected = addonSlected[0];
    let keys = Object.keys(firstAddonSlected);
    let selAddonName = [];
    _.each(keys, (key, index) => {
      _.each(firstAddonSlected[key], (addon, addonIndex) => {
        if (addon.quantity === 1 && addon.groupName) {
          let name =
            addon.name +
            (addon.modifiers && addon.modifiers !== ""
              ? " [" + addon.modifiers + "]"
              : "");
          selAddonName.push(name);
        }
      });
    });
    return selAddonName;
  }
  @action addItemGroupByAddons(itemModal) {
    let item = itemModal.item;

    // Check if the Advocado token expiry is still valid
    const tokenExpiry = localStorage.getItem(
      `${this.menuStore.controller}_advocado_token_expiry`
    );
    const now = new Date().getTime();
    const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;

    // If token is valid and a membership price exists, update the item price
    if (useMembership && item.membershipPrice) {
      item.price = item.membershipPrice.price;
      item.priceName = item.membershipPrice.priceName;
    }

    let addons = itemModal.addons;
    let notes = itemModal.notes;
    let isUpdate = itemModal.isUpdate;
    let reward = itemModal.rewardItem;
    let isRwardItem = false;
    if (reward && reward.redeem_code && reward.redeem_code !== "") {
      isRwardItem = true;
    }
    let entry = null;
    let is_found = false;
    for (let i = 0; i < this.entries.length; i++) {
      if (item.id === this.entries[i].item.id) {
        let rewardEntry = this.entries[i].reward;
        let isRwardEntryItem = false;
        if (
          rewardEntry &&
          rewardEntry.redeem_code &&
          rewardEntry.redeem_code !== ""
        ) {
          isRwardEntryItem = true;
        }
        is_found = this.getAddonsIds(this.entries[i].addons, addons);
        if (
          !isRwardItem &&
          !isRwardEntryItem &&
          is_found &&
          notes[0] === this.entries[i].notes[0]
        ) {
          entry = this.entries[i];
          break;
        }
      }
    }
    if (entry) {
      if (addons === null) {
        entry.addons.push(this.menuStore.cloneAddon(item));
      } else {
        if (isUpdate) {
          entry.addons = [];
        }
        _.each(addons, (addon) => {
          entry.addons.push(addon);
        });
      }
      if (notes === null) {
        entry.notes.push([""]);
      } else {
        _.each(notes, (note) => {
          entry.notes.push(note);
        });
      }
    } else {
      this.entries.push(
        new CartEntry({
          item: item,
          addons: addons ? addons : [this.menuStore.cloneAddon(item)],
          notes: notes,
          reward: reward,
          reactionHandler: (itemId, quantity) => {
            this.quantity_map.set(itemId, quantity);
          },
        })
      );
    }
    this.resetEntries();
  }
  @action getEntry(item) {
    let entry = null;
    for (let i = 0; i < this.entries.length; i++) {
      if (item.id === this.entries[i].item.id) entry = this.entries[i];
    }
    return entry;
  }
  @action getItemQty(item) {
    let qty = 0;
    for (let i = 0; i < this.entries.length; i++) {
      if (item.id === this.entries[i].item.id) {
        qty = qty + this.entries[i].addons.length;
      }
    }
    //// console.log(qty,this.entries[0],item);
    return qty;
  }
  @action getRewardItemQty(item) {
    let qty = 0;
    for (let i = 0; i < this.entries.length; i++) {
      if (item.id === this.entries[i].item.id) {
        if (
          this.entries[i].reward &&
          this.entries[i].reward.id &&
          this.entries[i].reward.id !== ""
        ) {
          qty = 1;
        }
      }
    }
    //// console.log(qty,this.entries[0],item);
    return qty;
  }
  @action resetRewardItem(id) {
    let entries = [];
    for (let i = 0; i < this.entries.length; i++) {
      if (
        this.entries[i].reward &&
        this.entries[i].reward.redeem_code &&
        this.entries[i].reward.redeem_code !== ""
      ) {
      } else {
        entries.push(this.entries[i]);
      }
    }
    this.entries = entries;
    
    // Reset applied rewards when removing reward items
    this._resetAppliedRewards();
    
    this.resetEntries();
  }

  @action appliedRewardName() {
    let social = this.menuStore.social;
    let rewardName = "";

    // If multiple rewards applied, join up to 2 names
    if (social && Array.isArray(social.appliedRewards) && social.appliedRewards.length > 0) {
      const names = social.appliedRewards
        .slice(0, 2)
        .map((rw) => {
          const r = rw.selectedRedeem || rw;
          return (
            r.name || r.redeem_name || r.description || rw.name || "Reward"
          );
        })
        .filter(Boolean);
      if (names.length > 0) {
        return names.join(" + ");
      }
    }

    // Check if social rewards exist and return the name of the first reward
    if (
      social.rewards &&
      social.rewards.length > 0 &&
      social.rewards[0].redeem_name
    ) {
      rewardName = social.rewards[0].redeem_name;
    }
    // If not, check if social.redeem exists
    if (social.redeem) {
      // Return selectedRedeem name if available
      if (social.redeem.selectedRedeem && social.redeem.selectedRedeem.name) {
        rewardName = social.redeem.selectedRedeem.name;
      }
      // Or use social.redeem.name if available
      else if (social.redeem.name) {
        rewardName = social.redeem.name;
      }
      // Or fallback to social.redeem.description if present
      else if (social.redeem.description) {
        rewardName = social.redeem.description;
      }
    }

    // As an extra fallback, use social.name (top-level) if it exists
    if (!rewardName && social.name) {
      rewardName = social.name;
    }

    // If still empty, return a default text
    return rewardName || "[No Reward]";
  }

  // helpers (top of file or in a utils module)
  static TAX_CFG_TTL_MS = 24 * 60 * 60 * 1000; // 24 h
  taxConfigKey(controller) {
    return `${controller}_taxConfig`;
  }
  
  // Helper method to reset applied rewards
  _resetAppliedRewards() {
    if (this.menuStore.social) {
      if (this.menuStore.social.redeem) {
        delete this.menuStore.social.redeem;
      }
      if (this.menuStore.social.appliedRewards) {
        this.menuStore.social.appliedRewards = [];
      }
    }
  }

  // --- inside class CartStore ---
  taxConfig = null;

  @action
  async fetchTaxConfig(forceRefresh = false) {
    const cacheKey = this.taxConfigKey(this.menuStore.controller);

    /* 1️⃣  Try localStorage first */
    if (!forceRefresh) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          const parsed = JSON.parse(cached); // { data, savedAt }
          if (Date.now() - parsed.savedAt < CartStore.TAX_CFG_TTL_MS) {
            runInAction(() => {
              this.taxConfig = parsed.data;
            });
            return; // 👍  cache hit
          }
        } catch (err) {
          console.warn("Bad tax-config cache – ignoring", err);
        }
      }
    }

    /* 2️⃣  Fallback to the API */
    try {
      const res = await axios.post(
        "https://open-api.punchpoint.io/advocado/tax-info",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            controller: this.menuStore.controller,
          },
        }
      );

      // avoid optional-chaining
      if (res.data && res.data.success) {
        runInAction(() => {
          this.taxConfig = res.data.data;
        });

        /* 3️⃣  Persist fresh copy */
        localStorage.setItem(
          cacheKey,
          JSON.stringify({ data: res.data.data, savedAt: Date.now() })
        );
      } else {
        console.error("Failed to fetch tax config:", res.data);
      }
    } catch (err) {
      console.error("Error fetching tax config:", err);
    }
  }

  get appliedRewardDetails() {
    // console.log('[Rewards Debug][store.appliedRewardDetails] recompute');
    // Reference updateTimestamp to create MobX dependency and force updates
    // eslint-disable-next-line no-unused-vars
    const timestamp = this.updateTimestamp;
    // Now that taxConfig is available, proceed with the calculations.
    let baseTotal = this.entries.reduce((sum, entry) => {
      const entryTotal = this.entryTotal(entry);
      const { priceAmt } = this.calculateRewardDiscoutPrice(
        entry.reward,
        entryTotal
      );
      return sum + parseFloat(priceAmt);
    }, 0);

    const taxConfig = this.taxConfig || {};

    // Convert percentage strings to numbers (dividing by 100 to get decimal rates)
    const serviceChargeRate =
      parseFloat(taxConfig.pref_tax_before_percentage) / 100 || 0;

    // Calculate service charge and add it to the base total
    const serviceCharge = baseTotal * serviceChargeRate;
    baseTotal += serviceCharge;
    // For GST, if the percentage is negative, assume GST is inclusive.
    const rawGstRate = parseFloat(taxConfig.pref_tax1_percentage);
    const rawSstRate = parseFloat(taxConfig.pref_tax2_percentage);
    const gstIsInclusive = rawGstRate < 0;
    const sstIsInclusive = rawSstRate < 0;
    const gstRate = Math.abs(rawGstRate) / 100 || 0;
    const sstRate = Math.abs(rawSstRate) / 100 || 0;

    // Apply any discount (support up to 2 rewards, one per type)
    let discountValue = 0;
    let discountType = null;

    const computeDiscountForRedeem = (redeem, currentBaseTotal) => {
      let val = 0;
      if (!redeem || !redeem.type) return { val: 0 };
      switch (redeem.type) {
        case "dollarPercentage": {
          val = (currentBaseTotal * parseFloat(redeem.value || 0)) / 100;
          break;
        }
        case "dollarValue": {
          val = parseFloat(redeem.value || 0);
          break;
        }
        case "stored-value":
        case "cashback": {
          const customRebateAmount = parseFloat(redeem.customRebateAmount || 0);
          const voucherValue = parseFloat(redeem.voucherValue || 0);
          const balance = parseFloat(redeem.customRebateAmount || 0);
          const availableAmount =
            customRebateAmount > 0
              ? customRebateAmount
              : voucherValue > 0
              ? voucherValue
              : balance;
          val = Math.min(availableAmount, currentBaseTotal);
          break;
        }
        case "voucher": {
          const minSpend =
            redeem.voucherRules && redeem.voucherRules.minSpend
              ? redeem.voucherRules.minSpend
              : 0;
          let voucherAmount = 0;
          const voucherCustomRebateAmount = parseFloat(
            redeem.customRebateAmount || 0
          );
          const voucherValueAmount = parseFloat(redeem.voucherValue || 0);
          const voucherValueFallback = parseFloat(redeem.value || 0);
          if (redeem.voucherType === "dollarValue") {
            const availableAmount =
              voucherCustomRebateAmount > 0
                ? voucherCustomRebateAmount
                : voucherValueAmount > 0
                ? voucherValueAmount
                : voucherValueFallback;
            voucherAmount = availableAmount;
          } else if (redeem.voucherType === "item") {
            const extSkuMappingArr = Array.from(redeem.extSkuMapping || []);
            const matchedEntries = this.entries.filter((entry) => {
              if (extSkuMappingArr.length > 0) {
                return extSkuMappingArr.some((skuMapping) => {
                  const skuValue = skuMapping.sku || skuMapping.itemSku;
                  return (
                    skuValue &&
                    entry.item.sku &&
                    entry.item.sku.trim().toLowerCase() ===
                      skuValue.trim().toLowerCase()
                  );
                });
              }
              return false;
            });
            matchedEntries.sort(
              (a, b) => parseFloat(this.entryTotal(a)) - parseFloat(this.entryTotal(b))
            );
            voucherAmount = 0;
            if (matchedEntries.length > 0) {
              const entry = matchedEntries[0];
              const qty = entry.quantity || 1;
              voucherAmount = parseFloat(this.entryTotal(entry)) / qty;
            }
            val = voucherAmount;
          } else {
            const percentageValue =
              voucherValueAmount > 0 ? voucherValueAmount : voucherValueFallback;
            voucherAmount =
              (currentBaseTotal * parseFloat(percentageValue || 0)) / 100;
          }
          if (!minSpend || currentBaseTotal >= minSpend) {
            val = voucherAmount;
          } else {
            console.warn(
              `Voucher not applied: minSpend ${minSpend} not met. Base total: ${currentBaseTotal}`
            );
          }
          if (redeem.voucherRules && redeem.voucherRules.amountCapped) {
            val = Math.min(val, redeem.voucherRules.amountCapped);
          }
          break;
        }
        default: {
          console.warn("Unknown redeem type:", redeem.type);
        }
      }
      return { val };
    };

    // Prefer new multi-reward flow
    const social = this.menuStore.social || {};
    // console.log('[Rewards Debug][store.appliedRewardDetails] social snapshot', {
    //   redeem: social && social.redeem,
    //   appliedRewards: Array.isArray(social && social.appliedRewards)
    //     ? (social.appliedRewards || []).map(r => ({ id: r && (r.id || r.campaignId), type: r && r.type, voucherType: r && r.voucherType }))
    //     : []
    // });
    // console.log('[Rewards Debug][store.appliedRewardDetails] raw appliedRewards', social.appliedRewards);
    // console.log('[Rewards Debug][store.appliedRewardDetails] raw appliedRewards length', social.appliedRewards ? social.appliedRewards.length : 'undefined');
    // Merge legacy redeem and appliedRewards, then keep one per category
    const list = [];
    // Handle MobX observable array
    const appliedRewardsArray = social.appliedRewards;
    if (appliedRewardsArray && appliedRewardsArray.length > 0) {
      // console.log('[Rewards Debug][store.appliedRewardDetails] adding from appliedRewards', appliedRewardsArray.length);
      list.push(...appliedRewardsArray.slice());
    }
    if (social.redeem) {
      // console.log('[Rewards Debug][store.appliedRewardDetails] adding legacy redeem');
      list.push(social.redeem);
    }
    // console.log('[Rewards Debug][store.appliedRewardDetails] merged list length', list.length);
    const catOf = (rw) => {
      const r = rw && (rw.selectedRedeem || rw);
      const t = r && r.type;
      if (t === 'cashback' || t === 'stored-value') return 'rebate';
      if (t === 'voucher' || (r && r.voucherType)) return 'voucher';
      return t || 'unknown';
    };
    const seen = new Set();
    const appliedList = [];
    for (const rw of list) {
      const cat = catOf(rw);
      if (!seen.has(cat)) {
        seen.add(cat);
        appliedList.push(rw);
        if (appliedList.length === 2) break;
      }
    }
    if (appliedList.length > 0) {
      let runningBase = baseTotal;
      let totalDiscount = 0;
      // enforce one-per-type while computing (in case legacy data has dup types)
      const seenTypes = new Set();
      for (const rw of appliedList) {
        const redeem = rw.selectedRedeem || rw;
        const typeKey = catOf(redeem);
        if (seenTypes.has(typeKey)) continue;
        const { val } = computeDiscountForRedeem(redeem, runningBase);
        const applied = Math.min(val, runningBase);
        runningBase = Math.max(0, runningBase - applied);
        totalDiscount += applied;
        seenTypes.add(typeKey);
        discountType = "multi";
        // console.log('[Rewards Debug][store.appliedRewardDetails] step', { typeKey, applied, runningBase });
      }
      discountValue = totalDiscount;
    } else if (this.menuStore.social && this.menuStore.social.redeem) {
      // Legacy single reward flow
      const redeem =
        this.appliedReward ||
        this.menuStore.social.redeem.selectedRedeem ||
        this.menuStore.social.redeem;
      if (redeem && redeem.type) {
        const { val } = computeDiscountForRedeem(redeem, baseTotal);
        discountValue = val;
        discountType = redeem.type;
      } else {
        console.warn("Invalid redeem object – missing type");
      }
    }

    let gst;
    if (gstIsInclusive) {
      // When GST is inclusive, extract GST portion from the total.
      const netTotal = baseTotal / (1 + gstRate);
      gst = baseTotal - netTotal;
    } else {
      // GST is exclusive, so add it on top.
      gst = baseTotal * gstRate;
      baseTotal += gst;
    }
    let sst;
    if (sstIsInclusive) {
      // When SST is inclusive, extract SST portion
      const taxableAmount = taxConfig.pref_tax2_include_before
        ? baseTotal
        : baseTotal - serviceCharge;
      const netTotal = taxableAmount / (1 + sstRate);
      sst = taxableAmount - netTotal;
      baseTotal += sst;
    } else {
      // SST is exclusive, so calculate based on taxable amount
      const taxableAmount = taxConfig.pref_tax2_include_before
        ? baseTotal
        : baseTotal - serviceCharge;
      sst = taxableAmount * sstRate;
      baseTotal += sst;
    }
    // Apply the discount only if value is valid
    if (!isNaN(discountValue) && discountValue > 0) {
      baseTotal = Math.max(0, baseTotal - discountValue);
    }
    return {
      discountValue,
      discountType,
      serviceCharge: serviceCharge.toFixed(2),
      serviceChargeRate: (serviceChargeRate * 100).toFixed(0) + "%",
      serviceChargeName: taxConfig.pref_service_charge_name || "Service Charge",
      gst: gst.toFixed(2),
      gstRate: (gstRate * 100).toFixed(0) + "%",
      gstName: taxConfig.pref_tax1_name || "GST",
      baseTotal: Math.max(0, baseTotal).toFixed(
        parseFloat(this.menuStore.currencyDecimal || 2)
      ),
      gstIsInclusive,
      sstIsInclusive,
      sst: sst.toFixed(2),
      sstRate: (sstRate * 100).toFixed(0) + "%",
      sstName: taxConfig.pref_tax2_name || "SST",
    };
  }

  // Breakdown discount per applied reward (max 2), in application order
  get appliedRewardsBreakdown() {
    // console.log('[Rewards Debug][store.appliedRewardsBreakdown] recompute');
    const social = this.menuStore.social || {};
    // Use same merge logic as appliedRewardDetails
    const merged = [];
    // Handle MobX observable array
    const appliedRewardsArray = social.appliedRewards;
    if (appliedRewardsArray && appliedRewardsArray.length > 0) {
      // console.log('[Rewards Debug][store.appliedRewardsBreakdown] adding from appliedRewards', appliedRewardsArray.length);
      merged.push(...appliedRewardsArray.slice());
    }
    if (social.redeem) {
      // console.log('[Rewards Debug][store.appliedRewardsBreakdown] adding legacy redeem');
      merged.push(social.redeem);
    }
    const getCategory = (rw) => {
      const r = rw && (rw.selectedRedeem || rw);
      const t = r && r.type;
      if (t === 'cashback' || t === 'stored-value') return 'rebate';
      if (t === 'voucher' || (r && r.voucherType)) return 'voucher';
      return t || 'unknown';
    };
    const seenCategories = new Set();
    let appliedList = [];
    for (const rw of merged) {
      const cat = getCategory(rw);
      if (!seenCategories.has(cat)) {
        seenCategories.add(cat);
        appliedList.push(rw);
        if (appliedList.length === 2) break;
      }
    }
    // console.log('[Rewards Debug][store.appliedRewardsBreakdown] merged count', merged.length, 'final count', appliedList.length);
    // console.log('[Rewards Debug][store.appliedRewardsBreakdown] appliedList items', appliedList.map(r => ({ type: getCategory(r), name: r.name || r.description })));

    // Base before discounts (includes item-level membership discount, service charge before discount step handled in details)
    let runningBase = this.entries.reduce((sum, entry) => {
      const entryTotal = this.entryTotal(entry);
      const { priceAmt } = this.calculateRewardDiscoutPrice(entry.reward, entryTotal);
      return sum + parseFloat(priceAmt);
    }, 0);

    const results = [];
    const seenTypes = new Set();

    const computeDiscountForRedeem = (redeem, currentBaseTotal) => {
      let val = 0;
      if (!redeem || !redeem.type) return 0;
      switch (redeem.type) {
        case "dollarPercentage":
          val = (currentBaseTotal * parseFloat(redeem.value || 0)) / 100;
          break;
        case "dollarValue":
          val = parseFloat(redeem.value || 0);
          break;
        case "stored-value":
        case "cashback": {
          const customRebateAmount = parseFloat(redeem.customRebateAmount || 0);
          const voucherValue = parseFloat(redeem.voucherValue || 0);
          const balance = parseFloat(redeem.customRebateAmount || 0);
          const availableAmount =
            customRebateAmount > 0
              ? customRebateAmount
              : voucherValue > 0
              ? voucherValue
              : balance;
          val = Math.min(availableAmount, currentBaseTotal);
          break;
        }
        case "voucher": {
          const minSpend =
            redeem.voucherRules && redeem.voucherRules.minSpend
              ? redeem.voucherRules.minSpend
              : 0;
          let voucherAmount = 0;
          const voucherCustomRebateAmount = parseFloat(redeem.customRebateAmount || 0);
          const voucherValueAmount = parseFloat(redeem.voucherValue || 0);
          const voucherValueFallback = parseFloat(redeem.value || 0);
          if (redeem.voucherType === "dollarValue") {
            const availableAmount =
              voucherCustomRebateAmount > 0
                ? voucherCustomRebateAmount
                : voucherValueAmount > 0
                ? voucherValueAmount
                : voucherValueFallback;
            voucherAmount = availableAmount;
          } else if (redeem.voucherType === "item") {
            const extSkuMappingArr = Array.from(redeem.extSkuMapping || []);
            const matchedEntries = this.entries.filter((entry) => {
              if (extSkuMappingArr.length > 0) {
                return extSkuMappingArr.some((skuMapping) => {
                  const skuValue = skuMapping.sku || skuMapping.itemSku;
                  return (
                    skuValue &&
                    entry.item.sku &&
                    entry.item.sku.trim().toLowerCase() === skuValue.trim().toLowerCase()
                  );
                });
              }
              return false;
            });
            matchedEntries.sort(
              (a, b) => parseFloat(this.entryTotal(a)) - parseFloat(this.entryTotal(b))
            );
            voucherAmount = 0;
            if (matchedEntries.length > 0) {
              const entry = matchedEntries[0];
              const qty = entry.quantity || 1;
              voucherAmount = parseFloat(this.entryTotal(entry)) / qty;
            }
            val = voucherAmount;
          } else {
            const percentageValue = voucherValueAmount > 0 ? voucherValueAmount : voucherValueFallback;
            voucherAmount = (currentBaseTotal * parseFloat(percentageValue || 0)) / 100;
          }
          if (!minSpend || currentBaseTotal >= minSpend) {
            val = voucherAmount;
          } else {
            val = 0;
          }
          if (redeem.voucherRules && redeem.voucherRules.amountCapped) {
            val = Math.min(val, redeem.voucherRules.amountCapped);
          }
          break;
        }
        default:
          break;
      }
      return val;
    };

    for (const rw of appliedList) {
      const redeem = rw.selectedRedeem || rw;
      const typeKey = getCategory(redeem);
      if (seenTypes.has(typeKey)) continue;
      const val = computeDiscountForRedeem(redeem, runningBase);
      const applied = Math.min(val, runningBase);
      runningBase = Math.max(0, runningBase - applied);
      const name = redeem.name || redeem.redeem_name || redeem.description || "Reward";
      results.push({ name, amount: applied, type: typeKey });
      seenTypes.add(typeKey);
    }

    return results;
  }

  @action checkValidRedeemAmount() {
    let social = this.menuStore.social;
    if (
      this.menuStore.isBWCMethod() &&
      social.rewards &&
      social.rewards.length > 0
    ) {
      let reObj = social.rewards[0];
      if (reObj.pos_redeem_method && reObj.pos_redeem_method === "percentage") {
        return "";
      } else {
        let pos_redeem_amount = parseFloat(reObj.pos_redeem_amount);
        let total = parseFloat(this.orderAmount);
        if (pos_redeem_amount > total) {
          return "error";
        }
      }
    }
    return "";
  }
  // Item must be an item model
  // addons is an array of objects
  @action addItem({ item, addons, notes }) {
    // Check if an entry is there previously
    // let entry = null;
    // for (let i = 0; i < this.entries.length; i++) {
    // if (item.id === this.entries[i].item.id) entry = this.entries[i];
    // }
    let entry = this.getEntry(item);
    
    // Enhance item with membership pricing if it has priceOptions with membership
    if (item.priceOptions && item.priceOptions.length >= 2) {
      const standardOption = item.priceOptions.find(opt => 
        opt && opt.name && String(opt.name).toLowerCase().includes('standard')
      );
      const membershipOption = item.priceOptions.find(opt => 
        opt && opt.name && String(opt.name).toLowerCase().includes('membership')
      );
      
      if (standardOption && membershipOption) {
        // Safely enhance item without modifying computed properties
        try {
          if (!item.standardPrice) {
            item.standardPrice = parseFloat(standardOption.price) || 0;
          }
          if (!item.hasMembershipPricing) {
            item.hasMembershipPricing = true;
          }
          // Don't override existing membershipPrice if it's computed
          if (!item.membershipPrice || typeof item.membershipPrice === 'undefined') {
            item.membershipPrice = membershipOption;
          }
          
          console.log('[CartStore.addItem] ✅ Enhanced main item with membership pricing:', item.name, 
            'Standard:', item.standardPrice, 'Member:', parseFloat(membershipOption.price) || 0);
        } catch (error) {
          console.log('[CartStore.addItem] ⚠️ Could not enhance item (computed property):', item.name, error.message);
          // Store enhancement data in a different way
          item._membershipPricingData = {
            standardPrice: parseFloat(standardOption.price) || 0,
            membershipPrice: membershipOption,
            hasMembershipPricing: true
          };
          console.log('[CartStore.addItem] ✅ Stored membership data in _membershipPricingData:', item.name);
        }
      } else {
        console.log('[CartStore.addItem] ❌ Could not enhance item:', item.name, 
          'priceOptions:', item.priceOptions ? item.priceOptions.map(opt => opt.name) : 'none');
      }
    }
    
    // Special handling for zero-base-price items with addon membership pricing
    if (parseFloat(item.price) === 0 && item.addons) {
      let totalStandardPrice = 0;
      let totalMembershipPrice = 0;
      let hasAddonMembershipPricing = false;
      
      // Calculate total pricing from addons
      Object.keys(item.addons).forEach(categoryKey => {
        const categoryAddons = item.addons[categoryKey];
        if (Array.isArray(categoryAddons)) {
          categoryAddons.forEach(addon => {
            if (addon.hasMembershipPricing && addon.standardPrice && addon.membershipPrice) {
              hasAddonMembershipPricing = true;
              totalStandardPrice += parseFloat(addon.standardPrice) || 0;
              totalMembershipPrice += parseFloat(addon.membershipPrice) || 0;
            }
          });
        }
      });
      
      if (hasAddonMembershipPricing) {
        try {
          if (!item.standardPrice) {
            item.standardPrice = totalStandardPrice;
          }
          if (!item.hasMembershipPricing) {
            item.hasMembershipPricing = true;
          }
          if (!item.membershipPrice || typeof item.membershipPrice === 'undefined') {
            item.membershipPrice = { price: totalMembershipPrice.toString(), priceName: `$ ${totalMembershipPrice.toFixed(2)}` };
          }
          
          console.log('[CartStore.addItem] ✅ Enhanced zero-price item with addon membership pricing:', item.name, 
            'Standard:', totalStandardPrice, 'Member:', totalMembershipPrice);
        } catch (error) {
          console.log('[CartStore.addItem] ⚠️ Could not enhance zero-price item (computed property):', item.name, error.message);
          item._membershipPricingData = {
            standardPrice: totalStandardPrice,
            membershipPrice: { price: totalMembershipPrice.toString(), priceName: `$ ${totalMembershipPrice.toFixed(2)}` },
            hasMembershipPricing: true
          };
          console.log('[CartStore.addItem] ✅ Stored addon membership data in _membershipPricingData:', item.name);
        }
      } else {
        console.log('[CartStore.addItem] ℹ️ Zero-price item has no addon membership pricing:', item.name);
      }
    }
    
    // If addons == null, we take from the base
    // Entry found, we need to update quantity and addonMap index
    if (entry) {
      if (addons === null) {
        entry.addons.push(this.menuStore.cloneAddon(item));
      } else {
        _.each(addons, (addon) => {
          // Enhance addons with membership pricing if they have it
          if (addon && addon.hasMembershipPricing && addon.standardPrice && addon.membershipPrice) {
            console.log('[CartStore.addItem] ✅ Addon already has membership pricing:', addon.name, 
              'Standard:', addon.standardPrice, 'Member:', addon.membershipPrice);
          } else {
            // Try to enhance addon with membership pricing from item's addons
            if (item.addons) {
              Object.keys(item.addons).forEach(categoryKey => {
                const categoryAddons = item.addons[categoryKey];
                if (Array.isArray(categoryAddons)) {
                  const sameNameAddons = categoryAddons.filter(a => a.name === addon.name);
                  if (sameNameAddons.length === 2) {
                    const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                    const standardPrice = prices[0];
                    const membershipPrice = prices[1];
                    
                    addon.standardPrice = standardPrice;
                    addon.membershipPrice = membershipPrice;
                    addon.hasMembershipPricing = true;
                    
                    console.log('[CartStore.addItem] ✅ Enhanced selected addon with membership pricing:', addon.name, 
                      'Standard:', standardPrice, 'Member:', membershipPrice);
                  }
                }
              });
            }
          }
          entry.addons.push(addon);
        });
      }

      if (notes === null) {
        entry.notes.push([""]);
      } else {
        _.each(notes, (note) => {
          entry.notes.push(note);
        });
      }
    } else {
      this.entries.push(
        new CartEntry({
          item: item,
          addons: addons ? addons : [this.menuStore.cloneAddon(item)],
          notes: notes,
          reactionHandler: (itemId, quantity) => {
            this.quantity_map.set(itemId, quantity);
          },
        })
      );
      
      // Enhance zero-price items AFTER they're added to cart (for BOTH cases)
      if (parseFloat(item.price) === 0) {
        const newEntry = this.entries[this.entries.length - 1];
        //console.log('[CartStore.addItem] 🔍 DEBUG: Zero-price item addon structure:', newEntry.item.name, 'addons:', newEntry.addons);
        
        if (newEntry && newEntry.addons && newEntry.addons.length > 0) {
          let totalStandardPrice = 0;
          let totalMembershipPrice = 0;
          let hasAddonMembershipPricing = false;
          
          // Calculate total pricing from selected addons
          newEntry.addons.forEach((addonGroup, groupIndex) => {
            //console.log('[CartStore.addItem] 🔍 DEBUG: Addon group', groupIndex, ':', addonGroup);
            
            if (Array.isArray(addonGroup)) {
              // Direct array structure
              addonGroup.forEach(addon => {
                //console.log('[CartStore.addItem] 🔍 DEBUG: Direct addon:', addon.name, 'quantity:', addon.quantity, 'hasMembershipPricing:', addon.hasMembershipPricing);
                if (addon.quantity > 0 && addon.hasMembershipPricing && addon.standardPrice && addon.membershipPrice) {
                  hasAddonMembershipPricing = true;
                  totalStandardPrice += parseFloat(addon.standardPrice) || 0;
                  totalMembershipPrice += parseFloat(addon.membershipPrice) || 0;
                  //console.log('[CartStore.addItem] ✅ Found membership addon:', addon.name, 'Standard:', addon.standardPrice, 'Member:', addon.membershipPrice);
                }
              });
            } else if (typeof addonGroup === 'object') {
              // Object structure with categories
              Object.keys(addonGroup).forEach(categoryKey => {
                const categoryAddons = addonGroup[categoryKey];
                //console.log('[CartStore.addItem] 🔍 DEBUG: Category', categoryKey, ':', categoryAddons);
                
                if (Array.isArray(categoryAddons)) {
                  categoryAddons.forEach(addon => {
                    //console.log('[CartStore.addItem] 🔍 DEBUG: Category addon:', addon.name, 'quantity:', addon.quantity, 'hasMembershipPricing:', addon.hasMembershipPricing);
                    if (addon.quantity > 0 && addon.hasMembershipPricing && addon.standardPrice && addon.membershipPrice) {
                      hasAddonMembershipPricing = true;
                      totalStandardPrice += parseFloat(addon.standardPrice) || 0;
                      totalMembershipPrice += parseFloat(addon.membershipPrice) || 0;
                      //console.log('[CartStore.addItem] ✅ Found membership addon:', addon.name, 'Standard:', addon.standardPrice, 'Member:', addon.membershipPrice);
                    }
                  });
                }
              });
            }
          });
          
          if (hasAddonMembershipPricing) {
            try {
              if (!newEntry.item.standardPrice) {
                newEntry.item.standardPrice = totalStandardPrice;
              }
              if (!newEntry.item.hasMembershipPricing) {
                newEntry.item.hasMembershipPricing = true;
              }
              if (!newEntry.item.membershipPrice || typeof newEntry.item.membershipPrice === 'undefined') {
                newEntry.item.membershipPrice = { price: totalMembershipPrice.toString(), priceName: `$ ${totalMembershipPrice.toFixed(2)}` };
              }
              
              console.log('[CartStore.addItem] ✅ Enhanced zero-price item AFTER cart add:', newEntry.item.name, 
                'Standard:', totalStandardPrice, 'Member:', totalMembershipPrice);
            } catch (error) {
              console.log('[CartStore.addItem] ⚠️ Could not enhance zero-price item AFTER cart add (computed property):', newEntry.item.name, error.message);
              newEntry.item._membershipPricingData = {
                standardPrice: totalStandardPrice,
                membershipPrice: { price: totalMembershipPrice.toString(), priceName: `$ ${totalMembershipPrice.toFixed(2)}` },
                hasMembershipPricing: true
              };
              console.log('[CartStore.addItem] ✅ Stored addon membership data AFTER cart add:', newEntry.item.name);
            }
          } else {
            console.log('[CartStore.addItem] ℹ️ Zero-price item has no selected addon membership pricing:', newEntry.item.name);
            
            // Fallback: Check if item has addons with membership pricing in menu
            if (item.addons) {
              //console.log('[CartStore.addItem] 🔍 DEBUG: Checking menu item addons for membership pricing...');
              let menuTotalStandardPrice = 0;
              let menuTotalMembershipPrice = 0;
              let hasMenuAddonMembershipPricing = false;
              
              Object.keys(item.addons).forEach(categoryKey => {
                const categoryAddons = item.addons[categoryKey];
                if (Array.isArray(categoryAddons)) {
                  categoryAddons.forEach(addon => {
                    if (addon.hasMembershipPricing && addon.standardPrice && addon.membershipPrice) {
                      hasMenuAddonMembershipPricing = true;
                      menuTotalStandardPrice += parseFloat(addon.standardPrice) || 0;
                      menuTotalMembershipPrice += parseFloat(addon.membershipPrice) || 0;
                      console.log('[CartStore.addItem] ✅ Found menu addon with membership pricing:', addon.name, 'Standard:', addon.standardPrice, 'Member:', addon.membershipPrice);
                    }
                  });
                }
              });
              
              if (hasMenuAddonMembershipPricing) {
                try {
                  if (!newEntry.item.standardPrice) {
                    newEntry.item.standardPrice = menuTotalStandardPrice;
                  }
                  if (!newEntry.item.hasMembershipPricing) {
                    newEntry.item.hasMembershipPricing = true;
                  }
                  if (!newEntry.item.membershipPrice || typeof newEntry.item.membershipPrice === 'undefined') {
                    newEntry.item.membershipPrice = { price: menuTotalMembershipPrice.toString(), priceName: `$ ${menuTotalMembershipPrice.toFixed(2)}` };
                  }
                  
                  console.log('[CartStore.addItem] ✅ Enhanced zero-price item with menu addon membership pricing:', newEntry.item.name, 
                    'Standard:', menuTotalStandardPrice, 'Member:', menuTotalMembershipPrice);
                } catch (error) {
                  console.log('[CartStore.addItem] ⚠️ Could not enhance zero-price item with menu addons (computed property):', newEntry.item.name, error.message);
                  newEntry.item._membershipPricingData = {
                    standardPrice: menuTotalStandardPrice,
                    membershipPrice: { price: menuTotalMembershipPrice.toString(), priceName: `$ ${menuTotalMembershipPrice.toFixed(2)}` },
                    hasMembershipPricing: true
                  };
                  console.log('[CartStore.addItem] ✅ Stored menu addon membership data:', newEntry.item.name);
                }
              }
            }
          }
        }
      }
    }

    //this.updateNotavilable(item);
    localStorage.setItem(
      `${this.menuStore.controller}_cart`,
      JSON.stringify(this.entries)
    );
  }

  @action removeItem(item) {
    for (let i = 0; i < this.entries.length; i++) {
      if (this.entries[i].item.id === item.id) {
        this.entries[i].addons = [];
        this.entries.splice(i, 1);
      }
    }
    let ntA = this.menuStore.notAvailable;
    var index = ntA.indexOf(item.id);
    if (ntA.length > 0 && index !== -1) {
      this.menuStore.notAvailable.splice(index, 1);
    }
    this.resetEntries();
    //localStorage.setItem(`${this.menuStore.controller}_cart`, JSON.stringify(this.entries));
  }
  @action removeItemIndexWise(item, ind) {
    this.entries[ind].addons = [];
    this.entries.splice(ind, 1);
    this.resetEntries();
    //localStorage.setItem(`${this.menuStore.controller}_cart`, JSON.stringify(this.entries));

    let ntA = this.menuStore.notAvailable;
    var index = ntA.indexOf(item.id);
    if (ntA.length > 0 && index !== -1) {
      this.menuStore.notAvailable.splice(index, 1);
    }
  }

  // For verification
  @action isCodeExpired() {
    const cachedCode = localStorage.getItem(
      `${this.menuStore.controller}_code`
    );
    if (cachedCode === null) return true;
    else {
      // Check if expired
      const timestamp = JSON.parse(cachedCode).timestamp;
      const expiryLength = this.menuStore.tagExpiry;

      const expiry = moment(timestamp).add(expiryLength, "millisecond");
      const now = moment();

      return now > expiry;
    }
  }

  @action isTagExpired() {
    const cachedTag = localStorage.getItem(this.menuStore.controller);
    if (cachedTag === null) return true;
    else {
      const timestamp = JSON.parse(cachedTag).timestamp;
      const expiryLength = this.menuStore.tagExpiry;

      const expiry = moment(timestamp).add(expiryLength, "millisecond");
      const now = moment();
      if (now > expiry) {
        localStorage.removeItem(`${this.menuStore.controller}`);
      }
      return now > expiry;
    }
  }

  // Check operating hours
  @action checkOperatingHour() {
    // Check if current time within opening/closing time
    const d = new Date();
    let cHr = d.getHours();
    let cMin = d.getMinutes();

    cMin = cMin < 10 ? "0" + cMin : cMin;
    let current = cHr + "" + cMin;
    let isClosed = true;
    _.each(this.menuStore.operatingHours, (operatingHour) => {
      let start = parseInt(operatingHour.start);
      let end = parseInt(operatingHour.end);

      let cTime = parseInt(current);
      if (start > cTime) {
        cTime = parseInt(24 + cHr + "" + cMin);
      }
      if (start > end) {
        end = end + 2400;
      }
      //// console.log(start,' <=', cTime,' &&',  end,' >= ',cTime);

      if (start <= cTime && end >= cTime) {
        isClosed = false;
        //break;
      }
    });

    if (isClosed === true) {
      return {
        title: this.menuStore.translation.shop_close,
        content: [
          this.menuStore.translation.shop_open,
          this.menuStore.operatingTime,
        ],
      };
    } else {
      return true;
    }
  }

  @action removeCachedCode() {
    localStorage.removeItem(`${this.menuStore.controller}_code`);
  }
  @action getOrderList() {
    let payloadOrder = [];
    let filterCustomizeOrder = [];
    _.map(this.entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          filterCustomizeOrder.indexOf(entry.item.id) < 0) ||
        !entry.item.isCustomize
      ) {
        payloadOrder.push(entry.payload());
        filterCustomizeOrder.push(entry.item.id);
      }
    });

    payloadOrder = payloadOrder.join(", ");
    return encodeURIComponent(payloadOrder);
  }
  @action getOrderItems() {
    let payloadOrder = [];
    let filterCustomizeOrder = [];
    _.map(this.entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          filterCustomizeOrder.indexOf(entry.item.id) < 0) ||
        !entry.item.isCustomize
      ) {
        payloadOrder.push(entry.item.name + "( " + entry.quantity + " )");
        filterCustomizeOrder.push(entry.item.id);
      }
    });
    return payloadOrder;
  }
  @action getCartItemsName() {
    let payloadOrder = [];
    let filterCustomizeOrder = [];
    _.map(this.entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          filterCustomizeOrder.indexOf(entry.item.id) < 0) ||
        !entry.item.isCustomize
      ) {
        payloadOrder.push(entry.item.name);
        filterCustomizeOrder.push(entry.item.id);
      }
    });
    return payloadOrder;
  }
  @action getSpotOrderItems(currency) {
    let payloadOrder = [];
    let filterCustomizeOrder = [];
    _.map(this.entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          filterCustomizeOrder.indexOf(entry.item.id) < 0) ||
        !entry.item.isCustomize
      ) {
        payloadOrder.push({
          title: entry.item.name,
          quantity: entry.quantity,
          price: { currency: currency, value: entry.item.price },
        });
        filterCustomizeOrder.push(entry.item.id);
      }
    });
    return payloadOrder;
  }
  @action prepareParams(onlinePaymentPayload) {
    let payloadOrder = this.getOrderList();

    let payload = "";
    let social = localStorage.getItem(`${this.menuStore.controller}_social`);

    if (social) {
// console.log(this.menuStore.memberDiscount);
      if (
        this.menuStore.memberDiscount !== "" &&
        this.menuStore.isBWCMethod()
      ) {
        let social1 = JSON.parse(social);
// console.log(social1);
        if (social1.rewards) {
          social1.rewards.push(this.menuStore.memberDiscount);
          social = JSON.stringify(social1);
        }
      }
      
      // Filter social data to reduce URL length
      const filteredSocial = this.filterSocialDataForOrder(social);
      // console.log('[Rewards Debug][prepareParams] original social', JSON.parse(social));
      // console.log('[Rewards Debug][prepareParams] filtered social', JSON.parse(filteredSocial));
      payload += "&social=" + filteredSocial;
    }
    const input_promocode = localStorage.getItem(`input_promocode`);

    if (input_promocode) {
      payload += "&input_promocode=" + input_promocode;
    }

    const preQuestionsInfo = localStorage.getItem(
      `${this.menuStore.controller}_preQuestions`
    );
    let uniqueArray = [];
    if (preQuestionsInfo) {
      let preQuestionsInfoArr = JSON.parse(preQuestionsInfo);
      _.map(this.menuStore.preQuestionFileds, (qa) => {
        if (qa.tag && uniqueArray.indexOf(qa.tag) < 0) {
          uniqueArray.push(qa.tag);
          payload +=
            "&" +
            qa.tag +
            "=" +
            (preQuestionsInfoArr[qa.tag] !== undefined
              ? encodeURIComponent(preQuestionsInfoArr[qa.tag])
              : " ");
          if (qa.save === "1") {
            preQuestionsInfoArr[qa.tag] = "";
          }
        }
      });
      let result = JSON.stringify(preQuestionsInfoArr);
      this.menuStore.savePreQuestion(result);
    }

    const postQuestionsInfo = localStorage.getItem(
      `${this.menuStore.controller}_postQuestions`
    );
    if (postQuestionsInfo && this.menuStore.postQuestionFileds.length > 0) {
      let postQuestionsInfoArr = JSON.parse(postQuestionsInfo);

      _.map(postQuestionsInfoArr, (val, i) => {
        if (
          [
            "currentStep",
            "error",
            "loading",
            "lastStep",
            "address_sub_field",
          ].indexOf(i) < 0
        ) {
          if (typeof val === "object") {
            payload += "&" + i + "=" + encodeURIComponent(JSON.stringify(val));
          } else {
            if (i === "input_contact" && postQuestionsInfoArr["phone_code"]) {
              val = postQuestionsInfoArr["phone_code"] + val;
            }
            payload += "&" + i + "=" + encodeURIComponent(val);
          }
        }
      });
      //let result=JSON.stringify(postQuestionsInfoArr);
      let result = JSON.stringify(postQuestionsInfoArr);
      this.menuStore.savePostQuestion(result);
    }
    //// console.log(payload,'tttt');

    if (this.remarks !== "") {
      payload += "&remark=" + encodeURIComponent(this.remarks);
    }
    if (this.takeAway) {
      payload += "&method=takeaway";
    }
    //// console.log(this.menuStore.login_option);
    let memberE = localStorage.getItem(
      `${this.menuStore.controller}_enable_membership_account`
    );
    if (this.menuStore.socialProviders.length > 0) {
      payload += "&enable_membership_account=" + memberE;
    }

    if (onlinePaymentPayload) {
      payload += "&" + onlinePaymentPayload;
    }
    payload += "&order=" + payloadOrder;
    let uuid = localStorage.getItem("uuid");
    payload += "&uuid=" + uuid;

    let receipt_id = localStorage.getItem("receipt_id");
    payload += "&receipt_id=" + receipt_id;
    return payload;
  }
  @action prepareOrderSummary(onlinePaymentPayload) {
    if (this.entries.length === 0) {
      return Promise.reject({
        title: this.menuStore.translation.cart_empty_prompt_title,
        content: this.menuStore.transation.cart_empty_prompt_info,
      });
    }
    if (!navigator.onLine) {
      return Promise.reject({
        title: this.menuStore.translation.no_internet,
      });
    }
    //// console.log(navigator.onLine);
    let payload = this.prepareParams(onlinePaymentPayload);
    return new Promise((resolve, reject) => {
      API.prepareOrderRequest(payload)
        .then((res) => {
          resolve(res);
          return;
        })
        .catch((err) => {
// console.log(err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummary failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummaryPost failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderAmount failed', err);
          reject({
            title: this.menuStore.translation.error,
            content: this.menuStore.translation.error_network,
          });
        });
    });
  }

  // Alternative method using POST to avoid long URLs
  @action prepareOrderSummaryPost(onlinePaymentPayload) {
    if (this.entries.length === 0) {
      return Promise.reject({
        title: this.menuStore.translation.cart_empty_prompt_title,
        content: this.menuStore.transation.cart_empty_prompt_info,
      });
    }
    if (!navigator.onLine) {
      return Promise.reject({
        title: this.menuStore.translation.no_internet,
      });
    }
    
    let payload = this.prepareParams(onlinePaymentPayload);
    
    // Debug: Log the complete payload being sent via POST
    // console.log('[Rewards Debug][prepareOrderSummaryPost] complete payload', payload);
    
    return new Promise((resolve, reject) => {
      API.prepareOrderRequestPost(payload)
        .then((res) => {
          resolve(res);
          return;
        })
        .catch((err) => {
          console.log(err);
          reject({
            title: this.menuStore.translation.error,
            content: this.menuStore.translation.error_network,
          });
        });
    });
  }

  @action prepareOrderAmount(customOrderId) {
    return new Promise((resolve, reject) => {
      API.calculateTaxs(customOrderId)
        .then((res) => {
          /*if(res.status!==1)
			   {
			   reject({
			   title: this.menuStore.translation.error,
			   content: this.menuStore.translation.error_network
			   }); 
			   }
			   else{*/
          resolve(res);
          //}
        })
        .catch((err) => {
// console.log(err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummary failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummaryPost failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderAmount failed', err);
          reject({
            title: this.menuStore.translation.error,
            content: this.menuStore.translation.error_network,
          });
        });
    });
  }
  // verificationCode is null if not required
  @action checkout(verificationCode, onlinePaymentPayload) {
// console.log("CHECKOUT");
    let isNoGateway = false;
    if (onlinePaymentPayload === "nogateway") {
      onlinePaymentPayload = "";
      isNoGateway = true;
    }
    if (this.entries.length === 0) {
      return Promise.reject({
        title: this.menuStore.translation.cart_empty_prompt_title,
        content: this.menuStore.transation.cart_empty_prompt_info,
      });
    }
    if (!navigator.onLine) {
      return Promise.reject({
        title: this.menuStore.translation.no_internet,
      });
    }
    //// console.log(navigator.onLine);
    let payload = this.prepareParams(onlinePaymentPayload);

    const cachedCode = localStorage.getItem(
      `${this.menuStore.controller}_code`
    );

    if (cachedCode) {
      verificationCode = JSON.parse(cachedCode).code;
    }
    return new Promise((resolve, reject) => {
      if (
        [
          "glencafe",
          "testglencafe",
          "54b9cab0-033c-4db9-9958-71ddce5e0e93",
        ].includes(this.menuStore.controller)
      ) {
        reject({
          title: this.menuStore.translation.error,
          content: "Reject Cash",
        });
      }
      API.createOrderOptimized(payload, verificationCode)
        .then((res) => {
          // Normalize response: convert object to raw string if needed
          const responseStr = (res && typeof res === 'object' && res.raw) ? res.raw : res;

          if (!responseStr || typeof responseStr !== 'string' || responseStr.indexOf("PHP Error") !== -1 || responseStr.length === 0) {
            console.log('🔴 NETWORK ERROR: checkout - PHP Error or empty response', res);
            reject({
              title: this.menuStore.transation.error,
              content: this.menuStore.transation.error_network,
            });
          } else {
            const orderIds = responseStr.split(":");
            const responseType = orderIds[0];

            console.log('📋 API Response Type:', responseType);
            console.log('📋 Full Response:', responseStr);
            
            if (responseType === "success") {
              this.menuStore.resetPostQA();
              localStorage.removeItem("is_opened_post_question");
              localStorage.removeItem("input_promocode");

              const orderId = orderIds[1];
              let spotOrderId = "";

              if (
                (onlinePaymentPayload.toString().indexOf('"method":"cash"') >
                  0 ||
                  isNoGateway) &&
                this.menuStore.isSpotMethod()
              ) {
                this.menuStore.spotOrderObj.orderId = orderId;
                this.menuStore.spotOrderObj.total.value = this.total.toString();
                this.menuStore.callSpotCreateOrder();
                spotOrderId = orderId;
              }

              // Generate or enhance price receipt data
              let priceReceiptData = null;
              try {
                // Try to use existing price receipt from onlinePaymentPayload if available
                if (onlinePaymentPayload && onlinePaymentPayload.priceReceipt) {
                  priceReceiptData =
                    typeof onlinePaymentPayload.priceReceipt === "string"
                      ? JSON.parse(onlinePaymentPayload.priceReceipt)
                      : onlinePaymentPayload.priceReceipt;
                } else {
                  // Create basic receipt data if not provided with all required fields
                  priceReceiptData = {
                    sub: this.sub_total,
                    sub_name: "SubTotal",
                    taxBefore: 0,
                    discount: 0,
                    discount_name: "Discount",
                    discount_note: "",
                    tax1: 0,
                    tax2: 0,
                    total: this.total,
                    total_name: "Total",
                  };
                }

                // Add tax configuration if available
                if (this.taxConfig) {
                  // Add tax rates if not already included
                  if (!priceReceiptData.tax1_rate && this.taxConfig.tax1_rate) {
                    priceReceiptData.tax1_rate = this.taxConfig.tax1_rate;
                  }
                  if (!priceReceiptData.tax2_rate && this.taxConfig.tax2_rate) {
                    priceReceiptData.tax2_rate = this.taxConfig.tax2_rate;
                  }
                  if (
                    !priceReceiptData.taxBefore_rate &&
                    this.taxConfig.taxBefore_rate
                  ) {
                    priceReceiptData.taxBefore_rate =
                      this.taxConfig.taxBefore_rate;
                  }
                }

                // Add applied reward details if available
                const rewardDetails = this.appliedRewardDetails;
                if (rewardDetails) {
                  if (
                    rewardDetails.discount_name &&
                    !priceReceiptData.discount_name
                  ) {
                    priceReceiptData.discount_name =
                      rewardDetails.discount_name;
                  }
                  if (
                    rewardDetails.discount_note &&
                    !priceReceiptData.discount_note
                  ) {
                    priceReceiptData.discount_note =
                      rewardDetails.discount_note;
                  }
                  if (rewardDetails.discount_amount) {
                    // Make sure discount is negative when it's a reduction (like in your example)
                    const discountValue = parseFloat(
                      rewardDetails.discount_amount
                    );
                    priceReceiptData.discount =
                      discountValue > 0 ? -discountValue : discountValue;
                  }
                }
              } catch (e) {
                console.error("Error preparing price receipt data:", e);
              }

              this.orderStore.addOrder({
                id: orderId,
                status: null, // defaulted to pending status
                cartEntries: this.entries,
                table: this.menuStore.getRealTagValue(),
                spotOrderId: spotOrderId,
                priceReceipt: priceReceiptData
                  ? JSON.stringify(priceReceiptData)
                  : null,
              });

              let tamount = this.total;
              // Empty the cart
              this.empty();
              resolve({
                title: this.menuStore.translation.success,
                content: `${this.menuStore.translation.checkout_response} ${orderId}`,
                orderId: orderId,
              });
              this.menuStore.sendGoogleAnalyticsOrder(tamount, orderId);
            } else if (responseType === "duplicated") {
              // Xử lý duplicated order
              console.log('🔄 DUPLICATED ORDER DETECTED');
              
              // Check if it's "duplicated:Unknown" - need to fetch recent orders
              if (orderIds[1] === "Unknown") {
                console.log('🔄 DUPLICATED:Unknown - Fetching recent orders from server');
                
                              // Fetch recent orders and store to localStorage
              this.fetchOrdersFromServer()
                .then((result) => {
                  console.log('✅ Recent orders fetched and stored for duplicated:Unknown');
                  resolve({
                    title: this.menuStore.translation.error,
                    content: this.menuStore.translation.duplicated_order_message,
                    isDuplicated: true,
                    orderId: null,
                    shouldFetchOrders: true,
                    ordersFound: result && result.orders && result.orders.length > 0
                  });
                })
                .catch((err) => {
                  console.log('❌ Error fetching orders for duplicated:Unknown:', err);
                  resolve({
                    title: this.menuStore.translation.error,
                    content: this.menuStore.translation.duplicated_order_message,
                    isDuplicated: true,
                    orderId: null
                  });
                });
              } else {
                // Regular duplicated order
              resolve({
                title: this.menuStore.translation.error,
                content: this.menuStore.translation.duplicated_order_message,
                isDuplicated: true,
                orderId: orderIds[1] || null
              });
              }
            } else {
              reject({
                title: this.menuStore.translation.error,
                content:
                  res !== "" ? res : this.menuStore.translation.error_network,
              });
            }
          }
        })
        .catch((err) => {
// console.log(err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummary failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderSummaryPost failed', err);
          console.log('🔴 NETWORK ERROR: prepareOrderAmount failed', err);
          reject({
            title: this.menuStore.translation.error,
            content: this.menuStore.translation.error_network,
          });
        });
    });
  }
  @action getYeahPayOrderItems(currency) {
    let payloadOrder = [];
    let filterCustomizeOrder = [];
    _.map(this.entries, (entry) => {
      if (
        (entry.item.isCustomize &&
          filterCustomizeOrder.indexOf(entry.item.id) < 0) ||
        !entry.item.isCustomize
      ) {
        // {
        // 	"name": "Product Name",
        // 	"number": 1,
        // 	"currency": "SGD",
        // 	"amount": 1.00
        // }
        let amt = parseInt(
          parseFloat(entry.item.price).toFixed(2).toString().replace(".", "")
        );
        amt = amt / 100;
        payloadOrder.push({
          name: entry.item.name,
          currency: currency,
          number: entry.quantity,
          amount: amt,
        });
        filterCustomizeOrder.push(entry.item.id);
      }
    });
    return payloadOrder;
  }

  // Async checkout - send order without waiting for response, then poll for status
  @action checkoutAsync(verificationCode, onlinePaymentPayload) {
    console.log('🚀 Starting async checkout...');
    
    let isNoGateway = false;
    if (onlinePaymentPayload === "nogateway") {
      onlinePaymentPayload = "";
      isNoGateway = true;
    }
    
    if (this.entries.length === 0) {
      return Promise.reject({
        title: this.menuStore.translation.cart_empty_prompt_title,
        content: this.menuStore.transation.cart_empty_prompt_info,
      });
    }
    
    if (!navigator.onLine) {
      return Promise.reject({
        title: this.menuStore.translation.no_internet,
      });
    }
    
    let payload = this.prepareParams(onlinePaymentPayload);
    const cachedCode = localStorage.getItem(`${this.menuStore.controller}_code`);
    
    if (cachedCode) {
      verificationCode = JSON.parse(cachedCode).code;
    }
    
    return new Promise((resolve, reject) => {
      if (
        [
          "glencafe",
          "testglencafe",
          "54b9cab0-033c-4db9-9958-71ddce5e0e93",
        ].includes(this.menuStore.controller)
      ) {
        reject({
          title: this.menuStore.translation.error,
          content: "Reject Cash",
        });
        return;
      }
      
      // Step 1: Send order request asynchronously (fire-and-forget)
      console.log('📤 Sending order request asynchronously...');
      API.createOrderAsync(payload, verificationCode)
        .then((asyncRes) => {
          console.log('✅ Order request sent:', asyncRes);
          
          // Step 2: Extract potential order ID from payload for polling
          let potentialOrderId = null;
          
          // Try to extract from UUID if available
          if (this.CustomOrderId) {
            potentialOrderId = this.CustomOrderId.substring(0, 8);
          } else {
            // Try to extract from receipt_id if available
            const receiptId = localStorage.getItem(`${this.menuStore.controller}_receipt_id`);
            if (receiptId && receiptId.includes('-')) {
              potentialOrderId = receiptId.split('-')[1]; // "0204" from "1754007737-0204"
            }
          }
          
          if (potentialOrderId) {
            console.log('🔍 Starting polling for order ID:', potentialOrderId);
            
            // Step 3: Start polling for order status
            API.pollOrderStatus(potentialOrderId, 15, 3000) // 15 attempts, 3s initial delay
              .then((pollResult) => {
                console.log('📋 Polling completed:', pollResult);
                
                if (pollResult.success) {
                  // Order found and successful
                  console.log('✅ Order completed successfully!');
                  
                  // Process successful order
                  this.menuStore.resetPostQA();
                  localStorage.removeItem("is_opened_post_question");
                  localStorage.removeItem("input_promocode");
                  
                  const orderId = pollResult.orderId;
                  let spotOrderId = "";
                  
                  if (
                    (onlinePaymentPayload.toString().indexOf('"method":"cash"') > 0 || isNoGateway) &&
                    this.menuStore.isSpotMethod()
                  ) {
                    this.menuStore.spotOrderObj.orderId = orderId;
                    this.menuStore.spotOrderObj.total.value = this.total.toString();
                    this.menuStore.callSpotCreateOrder();
                    spotOrderId = orderId;
                  }
                  
                  // Add order to order store
                  this.orderStore.addOrder({
                    id: orderId,
                    status: 2, // Success
                    cartEntries: this.entries,
                    orderNo: pollResult.orderNo || orderId,
                    timestamp: new Date().toISOString()
                  });
                  
                  // Clear cart
                  this.empty();
                  
                  resolve({
                    success: true,
                    orderId: orderId,
                    orderNo: pollResult.orderNo,
                    message: pollResult.msg || "Order completed successfully",
                    pollingAttempts: pollResult.attempts
                  });
                  
                } else {
                  // Order not found or failed
                  console.log('❌ Order not found or failed after polling');
                  
                  // Don't clear cart - let user retry
                  reject({
                    title: this.menuStore.translation.error,
                    content: "Order was sent but could not be confirmed. Please check with counter or try again.",
                    pollingAttempts: pollResult.attempts,
                    orderId: potentialOrderId
                  });
                }
              })
              .catch((pollError) => {
                console.log('❌ Polling error:', pollError);
                reject({
                  title: this.menuStore.translation.error,
                  content: "Order was sent but status check failed. Please check with counter.",
                  error: pollError
                });
              });
              
          } else {
            // No order ID available for polling
            console.log('⚠️ No order ID available for polling');
            
            // Order was sent but we can't track it
            resolve({
              success: true,
              message: "Order sent successfully. Please check with counter for confirmation.",
              note: "Order tracking not available"
            });
          }
        })
        .catch((asyncError) => {
          console.log('❌ Async order request failed:', asyncError);
          reject({
            title: this.menuStore.translation.error,
            content: "Failed to send order request. Please try again.",
            error: asyncError
          });
        });
    });
  }
  @action resetEntries() {
    // Reset applied rewards when entries are reset
    if (this.entries.length === 0) {
      this._resetAppliedRewards();
    }
    
    localStorage.setItem(
      `${this.menuStore.controller}_cart`,
      JSON.stringify(this.entries)
    );
  }
  @action empty() {
    _.each(this.entries, (entry) => {
      this.quantity_map.set(entry.item.id, 0);
    });

    this.entries = [];

    // Reset applied rewards when creating new cart
    this._resetAppliedRewards();

    localStorage.setItem(
      `${this.menuStore.controller}_cart`,
      JSON.stringify(this.entries)
    );
    this.menuStore.notAvailable = [];
  }
  @action checkQuantityValidation(item, qtyNew) {
    let tagObj = this.menuStore.checkTagAction();

    let qty = this.size + qtyNew;

    let freeQty = this.freeQty;
    //// console.log('cart store=>',qtyNew,'=>',freeQty,'qty=>',this.size);
    let price = parseFloat(item.price);
    if (price === 0) {
      freeQty = freeQty + qtyNew;
    }
    let erroMsg = "";
    if (
      price === 0 &&
      tagObj.max_free_qty &&
      tagObj.max_free_qty > -1 &&
      freeQty > tagObj.max_free_qty
    ) {
      erroMsg = tagObj.max_free_qty_message;
    }
    if (
      erroMsg === "" &&
      tagObj.max_qty &&
      tagObj.max_qty > -1 &&
      qty > tagObj.max_qty
    ) {
      erroMsg = tagObj.max_qty_message;
    }
    //// console.log(qtyNew,'=>',freeQty,'qty=>',qty);
    return erroMsg;
  }
  @action getAddonIndex(addonList) {
    let ind = 0;
    _.each(addonList, (addonGroup, mainIndex) => {
      if (ind === 0) {
        let keys = Object.keys(addonList[mainIndex]);
        _.each(keys, (key, index) => {
          _.each(addonList[mainIndex][key], (addon, addonIndex) => {
            if (addon.quantity > 0) {
              ind = mainIndex;
            }
          });
        });
      }
    });
    return ind;
  }
  @action getAddonsQty(addons) {
    let checkIndex = this.getAddonIndex(addons);
    let tQty = 0;
    _.each(addons, (addonList, addonListIndex) => {
      if (checkIndex === addonListIndex) {
        let keys = Object.keys(addonList);
        _.each(keys, (key, index) => {
          _.each(addonList[key], (addon, addonIndex) => {
            tQty += addon.quantity;
          });
        });
      }
    });
    return tQty;
  }

  @action getSetMealQty(addonList) {
    let qty = 0;
    _.each(addonList, (addonGroup, ind) => {
      _.each(addonGroup, (addon, index) => {
        qty += addon.quantity;
      });
    });
    return qty;
  }
  @action checkTotoitoastOutlet() {
    let status = "";
    let error = "";
    _.each(this.entries, (entry) => {
      let status1 = this.menuStore.checkPriceDisplay(entry.item);
      if (status !== "" && status1 !== status) {
        error = "error";
      }
      status = status1;
    });
    if (error !== "") {
      return error;
    }
    return status;
  }

  /**
   * Filters social data to reduce URL length by removing unnecessary fields
   * like full descriptions, terms & conditions, and other verbose data
   * that's not needed for order processing.
   * 
   * This can reduce URL length by 70-90% for users with extensive social data.
   * 
   * @param {string|object} socialData - The social data from localStorage
   * @returns {string} - Filtered and stringified social data
   */
  @action filterSocialDataForOrder(socialData) {
    if (!socialData) return null;
    
    try {
      const social = typeof socialData === 'string' ? JSON.parse(socialData) : socialData;
      
      // Only include essential data needed for order processing
      const filteredSocial = {
        // Essential user identification
        id: social.id,
        firstName: social.firstName,
        lastName: social.lastName,
        phoneNumber: social.phoneNumber,
        countryCallingCode: social.countryCallingCode,
        email: social.email,
        provider: social.provider,
        
        // Essential campaign data - only balances and IDs, not full descriptions
        campaignBalances: social.campaignBalances ? social.campaignBalances.map(campaign => ({
          campaignId: campaign.campaignId,
          campaignType: campaign.campaignType,
          name: campaign.name,
          amounts: campaign.amounts,
          vouchers: campaign.vouchers,
          balance: campaign.balance,
          expireDate: campaign.expireDate
        })) : [],
        
        // Essential membership data
        membership: social.membership ? social.membership.map(member => ({
          campaignId: member.campaignId,
          membershipTagName: member.membershipTagName,
          tierId: member.tierId,
          position: member.position
        })) : [],
        
        // Reward/Redemption data - CRITICAL for discount calculation
        redeem: social.redeem,
        appliedRewards: social.appliedRewards,
        
        // Other essential fields
        pdpa: social.pdpa,
        newCustomer: social.newCustomer,
        labels: social.labels || []
      };
      
      return JSON.stringify(filteredSocial);
    } catch (error) {
      console.error('Error filtering social data:', error);
      // Fallback to original data if filtering fails
      return typeof socialData === 'string' ? socialData : JSON.stringify(socialData);
    }
  }

  // Utility method to choose between GET and POST based on payload size
  @action prepareOrderSummaryOptimized(onlinePaymentPayload) {
    if (this.entries.length === 0) {
      return Promise.reject({
        title: this.menuStore.translation.cart_empty_prompt_title,
        content: this.menuStore.transation.cart_empty_prompt_info,
      });
    }
    if (!navigator.onLine) {
      return Promise.reject({
        title: this.menuStore.translation.no_internet,
      });
    }
    
    let payload = this.prepareParams(onlinePaymentPayload);
    
    // Debug: Log the complete payload being sent
    // console.log('[Rewards Debug][prepareOrderSummaryOptimized] complete payload', payload);
    
    // Check payload length - if it's too long, use POST method
    const payloadLength = payload.length;
    const maxGetLength = 2000; // Conservative limit for GET requests
    
    if (payloadLength > maxGetLength) {
      //console.log(`Payload too long (${payloadLength} chars), using POST method`);
      return this.prepareOrderSummaryPost(onlinePaymentPayload);
    } else {
      //console.log(`Payload length OK (${payloadLength} chars), using GET method`);
      return this.prepareOrderSummary(onlinePaymentPayload);
    }
  }
}

export default CartStore;
